import { systemCode, warName, xs_isMobile, xs_languageCode, xs_product_code } from '..';
import { appConfig, getLabel } from '../InitData';
import { SPORTS_WITH_STAGE_ID, ASIAN_HANDICAP, MAX_COLUMNS, HOURS_FILTERS, HOURS_FROM_FILTER, DAYS_FILTERS, DAYS_FROM_FILTER, ASIAN_HANDICAP_IT } from './constants';
import { getUrlPathSeoSettings, getUrlPathSeo } from './data';
import { getEnv } from './env';
import { getUrlPath } from './parseTournamentsByDate';
import { splitHandicap } from './splitHandicap';
import { concatUrlPathnames } from './sport-utils';
import $ from 'jquery';

export const isDevelopmentEnviroment = getEnv('REACT_APP_IS_DEVELOPMENT_ENVIROMENT');
export const REGEX_TRAILING_ZEROS = /^.+[^(_0)](_0) {1,5}$/mg;
//export const REGEX_URL = /^((http|https|ftp):\/\/)?((.*?):(.*?)@)?([a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])((\.[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])*)(:([0-9]{1,5}))?((\/.*?)(\?(.*?))?(#(.*))?)?$/;
export const REGEX_URL = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/;
export const REGEX_CF = /^(?:[A-Z][AEIOU][AEIOUX]|[AEIOU]X{2}|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]/i;
export const REPRINT_ID_ANCHOR = "!R";

export function loadLanguage() {
	//let lang = window.cg_LCODE || appConfig.language || appConfig.LANGUAGE;
	let lang = getQueryStringVariable("language");	
	if (lang == null) {
		lang = window.cg_LCODE || appConfig.language || appConfig.LANGUAGE;		
	}
    if (lang == null) {
        lang = getEnv('REACT_APP_LANGUAGE');
    }
	return lang == null ? 'IT': lang.toUpperCase();
}

export function loadLanguageXShop() {
	let localStorageLang = localStorage.getItem("xshop_lang");
	const configuredLangs = getEnv('REACT_APP_LANGUAGE').split(';');
	if (localStorageLang) {
		//checking if it is an available lang
		let isOk = false;
		for (let kl in configuredLangs) {
			if (configuredLangs[kl].toUpperCase() === localStorageLang.toUpperCase()) {
				isOk = true;
			}
		}
		if (!isOk) {
			localStorage.removeItem("xshop_lang");
			localStorageLang = null;
		}
	}
	let lang = getQueryStringVariable("language");	
	if (!lang) {
		lang = localStorageLang || window.cg_LCODE || appConfig.language || appConfig.LANGUAGE;		
	}
    if (!lang) { 
        lang = configuredLangs[0];
    }
    const choosedLang = lang? lang.toUpperCase(): 'IT';
	
	localStorage.setItem("xshop_lang", choosedLang);
	return choosedLang;
}

export function changeLanguageXShop(languageCode) {
	localStorage.setItem("xshop_lang", languageCode);
	window.location.reload();
}

export function getDaysLabels() {
    const days =  [
        getLabel('general.week_days.sun'),
        getLabel('general.week_days.mon'),
        getLabel('general.week_days.tue'),
        getLabel('general.week_days.wed'),
        getLabel('general.week_days.thu'),
        getLabel('general.week_days.fri'),
        getLabel('general.week_days.sat'),
    ];

    return days;
}

export function getMonthsLabels() {
    const months = [
        getLabel('general.months.jan'),
        getLabel('general.months.feb'),
        getLabel('general.months.mar'),
        getLabel('general.months.apr'),
        getLabel('general.months.may'),
        getLabel('general.months.jun'),
        getLabel('general.months.jul'),
        getLabel('general.months.aug'),
        getLabel('general.months.sep'),
        getLabel('general.months.oct'),
        getLabel('general.months.nov'),
        getLabel('general.months.dec'),
    ];

    return months;
}

export function getTimezoneOffset() {
	const conf = getConfiguration();
	if (conf.dbutc) {
		let offset = new Date().getTimezoneOffset();
		offset /= -60;
		return offset;	
	}
	
	return 0;
}

export function loadSessionToken() {
	let token = window.cg_TOKEN || appConfig.token || appConfig.TOKEN;
	if (token == null) {
		token = getQueryStringToken();		
	}
	return token == null? '':token;
}

export function getQueryStringToken() {
	let token = getQueryStringVariable("token");
	if (token) {
		if (window.appConfig) {
			window.appConfig['QUERY_STRING_TOKEN'] = token;
		}
	}else{
		token = window.appConfig?.['QUERY_STRING_TOKEN'];
	}
	return token;
}

export function loadSystemCode(apiDomain) {
	let systemCode = window.xs_systemCode || window.cg_SYSTEM_CODE || window.appConfig?.SYSTEM_CODE;
	if (systemCode == null) {
		systemCode = getQueryStringVariable("system_code");		
	}
	if (systemCode == null) {
		systemCode = getQueryStringVariable("systemCode");		
	}
	if (systemCode == null) {
		// pure javascript, to avoid jquery loading
		const xhr = new window.XMLHttpRequest();
		// false in the last parameter means "synchronous"
		xhr.open('GET', apiDomain + '/'+ warName + '/getSystemCodeFromDomain', false);
		xhr.send();
		if (xhr.status === 200) {
			systemCode = xhr.responseText;
		}
	}
	
	return systemCode === '' ? null: systemCode;
}

export function loadSystemCodeFromQueryString() {
	return getQueryStringVariable("system_code") || getQueryStringVariable("systemCode") || null;
}

export function loadIdPvr() {
	let idPvr = null;
	const cg_USER = window.cg_USER;
	if (typeof cg_USER === 'object' && cg_USER != null) {
		if (cg_USER.pvr) {
			idPvr = cg_USER.idConto;
		}
	}
	if (idPvr == null) {
		idPvr = appConfig && appConfig.ID_PVR;
	}
	if ((idPvr || null) == null) {
		idPvr = getQueryStringVariable("idPvr");		
	}
	return idPvr === '' ? null: idPvr;
}

export function getQueryStringVariable(variable) {
	let href_qs = decodeURIComponent(window.location.href);
	let query = href_qs.split('?')[1];
    if (query !== undefined) {
    	let vars = query.split('&');
    	for (let i = 0; i < vars.length; i++) {
    		let pair = vars[i].split('=');
    		if (decodeURIComponent(pair[0]) == variable) {
    			return decodeURIComponent(pair[1]);
    		}
    	}    	
    }
    return null;
}

export function getQueryStringMap() {

	let qs_map = {};
	let href =  decodeURIComponent(window.location.href);
	let query = href.split('?')[1];
	if (query !== undefined && query.length > 0) {
		let qs_variables = query.replace(/\?/g, "").split("&");

		for (let i = 0; i < qs_variables.length; i++) {
			let qs_single_variable = qs_variables[i];

			let qs_kv = qs_single_variable.split("=");
			
			let k = qs_kv[0];
			let v = qs_kv[1];

			qs_map[k] = v;
		}

	}
	return qs_map;

}

export function getCookie(cname) {
	var cookieRegex = new RegExp("^(?:.*;)?\\s*"+cname+"\\s*=\\s*([^;]+)(?:.*)?$");
	return (document.cookie.match(cookieRegex)||[null,null])[1];
	//return (document.cookie.match(/^(?:.*;)?\s*cg-force-desktop-mode\s*=\s*([^;]+)(?:.*)?$/)||[,null])[1];
}


export function addZero(n) {
    return (+n < 10)  ? `0${n}`: n;
}

export function parseDate(date) {
    return {
        YYYY: `${date.getFullYear()}`,
        MM: addZero(date.getMonth() + 1),
        DD: addZero(date.getDate()),
        HH: addZero(date.getHours()),
        mm: addZero(date.getMinutes()),
        ss: addZero(date.getSeconds()),
    };
}

export function compare2Dates(date1, date2) {
	if (date1.getTime() > date2.getTime()) {
		return 1;
	}
	if (date1.getTime() < date2.getTime()) {
		return -1;
	}
	return 0;
}

export function getDateFromTimestamp(timestamp) {
	var year = timestamp.substring(0, 4);
	var month = timestamp.substring(4, 6);
	var day = timestamp.substring(6, 8);
	var hours = timestamp.substring(9, 11);
	var minutes = timestamp.substring(12, 14);
	
	var date = new Date();
	date.setYear(parseInt(year, 10));
	date.setMonth(parseInt(month, 10)-1, parseInt(day, 10));
	date.setHours(parseInt(hours, 10));
	date.setMinutes(parseInt(minutes, 10));
	date.setSeconds(0);
	
	return date;
}

export function getDBTimestampFromDate(date) {
    if (!date) {
    	date = new Date();
    }

    const pd = parseDate(date);

    return `${pd.YYYY}${pd.MM}${pd.DD} ${pd.HH}:${pd.mm}:00`;
}

export function getLocaleTimestamp(timestamp) {
	if (timestamp.length === 8) {
		timestamp = timestamp + " 00:00";
	}
	const year = timestamp.substring(0, 4);
	const month = timestamp.substring(4, 6);
	const day = timestamp.substring(6, 8);
	const hours = timestamp.substring(9, 11);
	const minutes = timestamp.substring(12, 14);
	
    const date = new Date();
	date.setUTCFullYear(year);
	date.setUTCMonth(parseInt(month, 10) - 1, parseInt(day, 10));
	date.setUTCHours(parseInt(hours, 10));
	date.setUTCMinutes(parseInt(minutes, 10));
	
	return getDBTimestampFromDate(date);
}

// export function getLocaleTimestamp(timestamp) {
//     let date = null;

//     try {
//         // Timestamp without minutes and seconds
//         let regex = new RegExp('(?<year>\\d{4})(?<month>\\d{2})(?<day>\\d{2})');
//         if (regex.test(timestamp)) {
//             const r = regex.exec(timestamp).groups;
//             // Create date in UTC format (Z=UTC)
//             date = new Date(`${r.year}-${r.month}-${r.day}Z`);
//         }
        
//         // Timestamp with minutes and seconds
//         regex = new RegExp('(?<year>\\d{4})(?<month>\\d{2})(?<day>\\d{2}) (?<hours>\\d{2}):(?<minutes>\\d{2}):(?<seconds>\\d{2})');
//         if (regex.test(timestamp)) {
//             const r = regex.exec(timestamp).groups;
//             // Create date in UTC format (Z=UTC)
//             date = new Date(`${r.year}-${r.month}-${r.day}T${r.hours}:${r.minutes}Z`);
//         }
//     } catch (e) {
//         console.error(e);
//     }

// 	return getDBTimestampFromDate(date);
// }

export function getFormattedTimestamp() {
	const date = new Date();

    const pd = parseDate(date);

	return `${pd.DD}/${pd.MM}/${pd.YYYY} ${pd.HH}:${pd.mm}`;
}

export function getFormattedFullTimestamp() {
	try {
		const pad = (n,s=2) => (`${new Array(s).fill(0)}${n}`).slice(-s);
		const d = new Date();
		
		return `${pad(d.getFullYear(),4)}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.${pad(d.getMilliseconds(),3)}`;
	
	}catch(err) {
		console.error(err);
	}
}

export function getFormattedFullTimestampTZ() {
	try {
		const pad = (n,s=2) => (`${new Array(s).fill(0)}${n}`).slice(-s);
		const d = getUTCDateNow();
		
		return `${pad(d.getFullYear(),4)}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.${pad(d.getMilliseconds(),3)}Z`;
	
	}catch(err) {
		console.error(err);
	}
}

export function getUTCDateNow() {
	let offset = new Date().getTimezoneOffset();
	offset /= 60;
	let dateNow = new Date();
	dateNow.setHours(dateNow.getHours() + offset);
	return dateNow; 
}

window.getUTCDateNow = getUTCDateNow;

export function getFormattedDateNow() {
	const nowTimestamp = getNowTimestamp('YYYYMMDD HH:MM');
	return formatDate(nowTimestamp, true)
}


export function getShowableTicketId(id){
	if(!id){
		return ''
	}
	const conf = getConfiguration();
	const obfuscateTicketId = conf.rs?.otid;
	return obfuscateTicketId? getHiddenTicket(id) : id;
}
// input is a timestamp YYYYMMDD hh:mm
export function formatDate(times, skipUtcConversion = false) {
	const conf = getConfiguration();
	skipUtcConversion = skipUtcConversion == null ? false : skipUtcConversion;
	if (conf.dbutc && !skipUtcConversion) {
		// converting the input timestamp into a similar timestamp with the offset of this browser
		times = getLocaleTimestamp(times); 
	}
	const timestamp = times;
	const date = {};
	const year = timestamp.substring(0, 4);
	const yearTrunc = year.substring(2, 4);
	const month = timestamp.substring(4, 6);
	const day = timestamp.substring(6, 8);
    let hours = 0;
    let minutes = 0;
    let seconds = 0;
    if (timestamp.length > 8) {
        hours = timestamp.substring(9, 11);
        minutes = timestamp.substring(12, 14);
        seconds = '00';
    }

	if (timestamp.length >= 17) {
		seconds = timestamp.substring(15, 17);
    }
	
	let mms = minutes;
	if (mms.length === 1) {
		mms += '0';
	}
	
	let dds = day;
	if (dds.length === 1) {
		dds = `0${dds}`;
	}
	
	let mons = month;
	if (mons.length === 1) {
		mons = `0${mons}`;
	}
	
	dds = day;
	date.formatted = `${dds}/${mons}/${year} ${hours}:${mms}`;
	date.formatted_no_hour = `${dds}/${mons}/${year}`;
	date.formatted_day_month = `${dds}/${mons}`;
	date.formatted_trunc_year = `${dds}/${mons}/${yearTrunc} ${hours}:${mms}`;
	date.year = parseInt(year, 10);
	date.month = parseInt(month, 10);
	date.day = parseInt(day, 10);
	date.hours = parseInt(hours, 10);
	date.minutes = parseInt(minutes, 10);
	date.seconds = parseInt(seconds, 10);
	date.time = `${hours}:${mms}`;
	
	return date;	
}

export function getNowTimestamp(format) {
	let db_string = '';

	let formato = format.toUpperCase();
    const date = parseDate(new Date());
    
	if (formato.indexOf('YYYYMMDD') >= 0) {
		db_string += date.YYYY;
		db_string += date.MM;
		db_string += date.DD;
	}
	
	if (formato.indexOf('HH:MM') >= 0) {
		db_string += ' ';
		db_string += date.HH;
		db_string += ':'
		db_string += date.mm;
	}
	
	if (formato.indexOf('SS') >= 0) {
		db_string += ':';
		db_string += date.ss;
	}

	return db_string;
}

//window.formatDate = formatDate;

export function formatDateWithMonth(date) {
    const fDate = formatDate(date);
	const dateString = `${fDate.year}-${addZero(fDate.month)}-${addZero(fDate.day)}T${addZero(fDate.hours)}:${addZero(fDate.minutes)}:00`;
	date = new Date(dateString);

	const relativeDay = getRelativeDay(date);
	if (relativeDay) {
		return {
			dayMonth: relativeDay,
			dayMonthShort: relativeDay,
			dayMonthTime: `${relativeDay} - ${fDate.time}`,
			dayMonthYear: relativeDay,
			dayMonthYearTime: `${relativeDay} - ${fDate.time}`
		};
	} else {
        const months = getMonthsLabels();
		const monthNumber = date.getMonth() + 1;
		const monthDesc = months[date.getMonth()];
	
		return {
			dayMonth: `${fDate.day} ${monthDesc}`,
			dayMonthShort: `${addZero(fDate.day)}.${addZero(monthNumber)}`,
			dayMonthTime: `${fDate.day} ${monthDesc} - ${fDate.time}`,
			dayMonthYear: `${fDate.day} ${monthDesc} ${fDate.year}`,
			dayMonthYearTime: `${fDate.day} ${monthDesc} ${fDate.year} - ${fDate.time}`
		};
	}
}

function getRelativeDay(date) {
	try {
		const todayLabel = getLabel('general.today');
		const tomorrowLabel = getLabel('general.tomorrow');
		if (todayLabel == null || tomorrowLabel == null) {
			return null;
		}

		const inputDate = new Date(date);
		inputDate.setHours(0, 0, 0, 0);
        const inputDateTime = inputDate.getTime();

		const today = new Date();
		today.setHours(0, 0, 0, 0);
		if (today.getTime() === inputDateTime) {
			return todayLabel;
		}

		const tomorrow = new Date(today)
		tomorrow.setDate(today.getDate() + 1);
		if (tomorrow.getTime() === inputDateTime) {
			return tomorrowLabel;
		}
	} catch(e) {
		console.error(e);
		return null;
	}

	return null;
}

export function formatDateWithWeekDay(date) {
	const fDate = formatDate(date);
    const dateString = `${fDate.year}-${addZero(fDate.month)}-${addZero(fDate.day)}T${addZero(fDate.hours)}:${addZero(fDate.minutes)}:00`
	date = new Date(dateString);
	
    const di = date.getDay();
    let day = null;
    let dayMonth = null;
    let dayMonthShort = null;
    let dayMonthYear = null;

	const relativeDay = getRelativeDay(date);
	if (relativeDay) {
		day = relativeDay;
		dayMonth = relativeDay;
        dayMonthShort = `${addZero(fDate.day)}.${addZero(fDate.month)}`;
		dayMonthYear = relativeDay;
	} else {
        const days =  getDaysLabels();
		const mi = date.getMonth();
        const months = getMonthsLabels();
		day = `${days[di]} ${fDate.day}`;
		dayMonth = `${day} ${months[mi]}`;
        dayMonthShort = `${addZero(fDate.day)}.${addZero(fDate.month)}`;
		dayMonthYear = `${dayMonth} ${fDate.year}`;
	}

    return {
        date: fDate.day,
        month: fDate.month,
        weekDay: di === 0 ? 7: di,
        day: `${day}`,
        dayTime: `${day} - ${fDate.time}`,
        dayMonth: `${dayMonth}`,
        dayMonthShort,
        dayMonthTime: `${dayMonth} - ${fDate.time}`,
        dayMonthYear: `${dayMonthYear}`,
        dayMonthYearShort: `${dayMonthShort}.${fDate.year}`,
        dayMonthYearTime: `${dayMonthYear} - ${fDate.time}`
    };
}

export function getSysDateInFormat(format, dayPlus = 0) {
	let d = new Date();
	let date = d.getDate();
	date = date + dayPlus;
	d.setDate(date);
	const y = d.getFullYear().toString();
	const m = addZero(d.getUTCMonth() + 1); //Months are zero based
	d = addZero(d.getDate());
    
	const d2 = new Date();
	const hh = addZero(d2.getHours());
	const mm = addZero(d2.getMinutes());
	const ss = addZero(d2.getSeconds());
	
	if (format === 'YYYY-MM-DD') {
		return  `${y}-${m}-${d}`;			
	}
	return `${y}${m}${d} ${hh}:${mm}:${ss}`;	
}

export function addDaysToDate(date,days) {
    var dat = new Date(date.valueOf());
    dat.setDate(dat.getDate() + days);
    return dat;
}

export function dateDiff(date1,date2) {
	var diff = {
		days: 	Math.floor((date2.getTime()-date1.getTime())/(24*3600*1000)),
		weeks: 	parseInt((date2.getTime()-date1.getTime())/(24*3600*1000*7), 10),
		months: (date2.getMonth()+12*date2.getFullYear())-(date1.getMonth()+12*date1.getFullYear()),
		years:	date2.getFullYear()-date1.getFullYear()
	}

	return diff;
}

export function oddToString(odd) {
    if (odd > 100) {
        return truncateDoubleTo(parseFloat(odd / 100.00), 2)
    } else {
        return null;
    }
}

export function oddToStringCheckbet(odd) {
	return truncateDoubleTo(parseFloat(odd / 100.00), 2);
}

export function getRanking(el, isLive = false) {
	const systemCode = getConfiguration().sys;
	// return (isLive && el.rksl?.[systemCode]) || el.rks?.[systemCode] || el.rnk || el.rk;
	if(isLive && el.rksl?.[systemCode]){
		return el.rksl[systemCode];
	}
	else if(!isLive && el.rks?.[systemCode]){
		return el.rks[systemCode];
	}
	return el.rnk || el.rk;
}

export function byRanking(a, b) {
	return a.ranking - b.ranking;
}

export function byDesc(a, b) {
    const [desc1, desc2] = (a.descrizione == null) ? [a.desc, b.desc]: [a.descrizione, b.descrizione];
    return desc1.trim().localeCompare(desc2.trim());
}

export default function byNegativeFirst(a, b) {
	const aId = a.idAggregata || a.id;
	const bId = b.idAggregata || b.id;

	if (aId < 0 && bId < 0) {
		return 0;
	} else if (aId < 0) {
		return -1;
	} else if (bId < 0) {
		return 1;
	}

	return 0;
}

export function getLSItemOrEmptyString(key) {
	let item = localStorage.getItem(key);
	if (item == null) {
		item = '';
	}
	return item;
}

export function getOutcomeSpread(handicap, tipoHandicap, draws, additionalData) {
	const result = splitHandicap(handicap, tipoHandicap, draws, additionalData, xs_languageCode);
	let toAppend = '';
    for (let i = 0; i < result.infoCalcolate; i++) {
        const info = result[`info${i + 1}`];
        if (info.length === 0) {
            continue;
        }
		toAppend += `${(i > 0 && toAppend.length > 0) ? '/': ''}${info}`;
	}
	return toAppend;
}

export function invertSign(intAsString) {
    if (intAsString[0] === '-') {
        return intAsString.slice(1);
    } else {
        return `-${intAsString}`;
    }
}

export function parseHandicap(desc, handicap, tipoHandicap, draws, additionalData, handleAsianHandicap = false, handicapInfo = null) {

    const result = splitHandicap(handicap, tipoHandicap, draws, additionalData, xs_languageCode, handicapInfo);
    if (tipoHandicap === 23 && handleAsianHandicap) {
        result.info1 = invertSign(result.info1);
    }

    let toAppend = '';
    if (desc.includes('@@')) {
        if (handicap == 0) {
            desc = desc.replace('@@H1@@', getGenericHandicapDescriptionPart(0, handicap, 1))
            .replace('@@H2@@', getGenericHandicapDescriptionPart(0, handicap, 2))
            .replace('@@H3@@', getGenericHandicapDescriptionPart(0, handicap, 3))
            .replace('@@H4@@', getGenericHandicapDescriptionPart(0, handicap, 4))
            .replace('@@H5@@', getGenericHandicapDescriptionPart(0, handicap, 5))
            .replace('@@H6@@', getGenericHandicapDescriptionPart(0, handicap, 6))
            .replace('@@H7@@', getGenericHandicapDescriptionPart(0, handicap, 7))
            .replace('@@H8@@', getGenericHandicapDescriptionPart(0, handicap, 8));
        } else {
            desc = desc.replace('@@H1@@', result.info1)
            .replace('@@H2@@', result.info2)
            .replace('@@H3@@', result.info3)
            .replace('@@H4@@', result.info4)
            .replace('@@H5@@', result.info5)
            .replace('@@H6@@', result.info6)
            .replace('@@H7@@', result.info7)
            .replace('@@H8@@', result.info8);
            if (tipoHandicap === 38 && !desc.includes(result.info2)) {
                desc += ' '+result.info2;
            }
        }
    } else if (desc.includes('{{')) {
        desc = desc.replace('{{H1}}', result.info1)
                    .replace('{{H2}}', result.info2)
                    .replace('{{H3}}', result.info3)
                    .replace('{{H4}}', result.info4)
                    .replace('{{H5}}', result.info5)
                    .replace('{{H6}}', result.info6)
                    .replace('{{H7}}', result.info7)
                    .replace('{{H8}}', result.info8);
    } else if (desc.indexOf(':') === -1 && handicap !== '0') {
        function appender(spaceChar) {
            for (let i = 0; i < result.infoCalcolate; i++) {
                const res = result[`info${i + 1}`];
                toAppend += `${i > 0 ? spaceChar: ''}${res.dia ? res.dia: res}`;
            }
        }

        if (desc === '') {
            // sto calcolando la descrizione da mostrare nella tabella HCP
            if (tipoHandicap === 55 || tipoHandicap == 64) {
                const baseSettlement = result.info1 === 0 && result.info2 === 0? "" :
                "(" + result.info1 + ':' + result.info2 + ") ";
                toAppend = toAppend + baseSettlement + result.info3;
            } else if (tipoHandicap === 70) {
                const baseSettlement = result.info2 === 0 && result.info3 === 0? "" :
                " (" + result.info2 + ':' + result.info3 + ")";
                toAppend = toAppend + result.info1 + baseSettlement;
            } else if (tipoHandicap === 39) {
                toAppend = `${result.info1 / 100}, ${result.info2 / 100}`;
            } else if(tipoHandicap === 34){
            	toAppend = `${result.info1}, ${result.info2} / ${result.info4}`;
            } else {
                appender('/');
            }  	
        } else {
            if (tipoHandicap === 39) {
                toAppend = `${result.info1 / 100}, ${result.info2 / 100}`;
            } else {
                appender(' ');
            }
        }
    }
    
    if (desc === '') {
        return toAppend;
    } else {
        return `${desc} ${toAppend}`;
    }
}

export function getBetDesc(bet) {
	if ((bet.calculateHandicapDescription) && !bet.isCompact) {
		return parseHandicap(bet.desc, bet.handicap, bet.tipoHandicap, bet.draws, bet.dia);
	} else {
        return bet.desc;
	}
}

function getTournamentsHighlightsImages() {
	const conf = getConfiguration();
	const thi = conf.thi;
    const htc = conf.htc?.ht ?? null;
	let imagesMap = new Map();

    if (thi?.length > 0) {
        try {
            const imagesData = JSON.parse(thi);
            imagesMap = new Map(Object.entries(imagesData));
        } catch (e) {}
    }

    if (htc?.length > 0) {
        htc.forEach(t => {
            if (t.url?.length > 0) {
                imagesMap.set(t.id, t.url);
            }
        });
    }
	
	return imagesMap;
}

export function getTorneiInEvidenza(sports, currentFilter) {
	const conf = getConfiguration();
    const tie = conf.tie;
	
    const tournamentsRanking = {};
    tie.forEach((t, i) => tournamentsRanking[t] = i + 1);
    function byTournamentsRanking(a, b) {
		return tournamentsRanking[a.id] - tournamentsRanking[b.id];
    }
	const imagesMap = getTournamentsHighlightsImages();
    let inEvidenzaSports = [];
    const sportById = new Map();
    let tournamentsCount = 0;
    let tournamentsList = [];
    let tournamentsIds = [];
    const tournamentsMap = new Map();
    sports.forEach(sp => {
        if (sp.filters[currentFilter] !== undefined) {
            const categories = [];
            const tournaments = [];
            sp.categories.forEach(c => {
                const filteredTournaments = c.tournaments.filter(t => t.filters[currentFilter] !== undefined && tie.indexOf(t.id) !== -1);
                if (filteredTournaments.length > 0) {
                    const category = {
                        ...c,
                        tournaments: []
                    };
                    categories.push(category);
                    filteredTournaments.forEach(t => {
						const backgroundImage = imagesMap.get(t.uniqueId) || null;
                        const tournament = {
							backgroundImage,
							ranking: tournamentsRanking[t.id],
                            aggregate: t.aggregate,
                            categoryIcon: t.categoryIcon,
                            categoryRef: t.categoryRef,
                            descrizione: t.descrizione,
                            eventsCount: t.eventsCount,
                            eventsCountByFilter: t.eventsCountByFilter,
                            iconClass: t.iconClass,
                            id: t.id,
                            isLive: t.isLive,
                            sportRef: t.sportRef,
                            uniqueId: t.uniqueId,
                            urlPath: (sp.urlPath+'/'+t.descrizione.replace(/\s+/g, '-')).toLocaleLowerCase(),
                            urlPathSeo: getUrlPathSeo(t),
                            urlPathSeoSettings: getUrlPathSeoSettings(t),
                            urlPathSuffix: `_${t.uniqueId}`
                        };
                        category.tournaments.push(tournament);
                        tournaments.push(tournament);
                        tournamentsList.push(tournament);
                        tournamentsIds.push(t.uniqueId);
                        tournamentsMap.set(t.uniqueId, tournament);
                        tournamentsCount++;
                    });
                }
            });
            if (tournaments.length > 0) {
                const competitions = tournaments.sort(byTournamentsRanking);
                const sport = {
                    id: sp.id,
                    iconClass: sp.iconClass,
                    descrizione: sp.descrizione,
                    categories,
                    competitions,
                };
                inEvidenzaSports.push(sport);
                sportById.set(sport.id, sport);
            }
        }
	});
	
	return {
		sportsList: inEvidenzaSports.sort(byRanking),
        tournamentsList: tournamentsList.sort(byTournamentsRanking),
		tournamentsIds,
        tournamentsMap,
		tournamentsCount
	}
}

export function getFavoriteTournamentsData(sports, favoritesMap, currentFilter) {
    let favoriteTournaments = [];
    let tournamentsCount = 0;
    let tournamentsIds = [];
    sports.forEach(sport => {
        if (sport.filters[currentFilter] !== undefined) {
            const tournaments = [];
            sport.categories.forEach(country => {
                country.tournaments.filter(tournament => {
                    return tournament.filters[currentFilter] !== undefined && favoritesMap[tournament.uniqueId] !== undefined;
                }).forEach(tournament => {
                    tournaments.push({
                        id: tournament.id,
                        uniqueId: tournament.uniqueId,
                        descrizione: tournament.descrizione,
                        categoryRef: tournament.categoryRef,
                        sportRef: tournament.sportRef,
                        isLive: tournament.isLive,
                        eventsCount: tournament.eventsCount,
                        iconClass: tournament.iconClass,
                        categoryIcon: tournament.categoryIcon,
						sportUrlPath: tournament.sportUrlPath,
						sportUrlPathSuffix: tournament.sportUrlPathSuffix,
						categoryUrlPath: tournament.categoryUrlPath,
						categoryUrlPathSeo: tournament.categoryUrlPathSeo,
						categoryUrlPathSeoSettings: tournament.categoryUrlPathSeo,
						categoryUrlPathSuffix: tournament.categoryUrlPathSeo,
						urlPath: tournament.urlPath,
						urlPathSeo: tournament.urlPathSeo,
						urlPathSeoSettings: tournament.urlPathSeoSettings,
						urlPathSuffix: tournament.urlPathSuffix
                    });
                    tournamentsIds.push(tournament.uniqueId);
                    tournamentsCount++;
                });
            });
            if (tournaments.length > 0) {
                favoriteTournaments.push({
                    id: sport.id,
                    iconClass: sport.iconClass,
                    descrizione: sport.descrizione,
                    competitions: tournaments,
                });
            }
        }
	});
	
	return {
		sportsList: favoriteTournaments.sort(byRanking),
		tournamentsIds,
		tournamentsCount
	}
}

// Ritorna il grupppo principale se esiste, altrimenti torna il primo
export function getPrincipaleOPrimoGruppo(aggregate) {
	let principale = aggregate.find(ag => ag?.isPrincipale);
	return principale || aggregate.sort(byRanking)[0];
}

// Ritorna il grupppo principale se esiste, altrimenti torna il primo
export function getPrincipaleOPrimoMacroGruppo(macrogruppi) {
	const principale = macrogruppi.find(mg => mg.isPrincipale);
	return principale || macrogruppi[0];
}

export function filtraParametriche(bets) {
	const parametricheMap = new Set();
    return bets.filter(bet => {
        if (bet.parametrica) {

            // Questo controllo è stato rimosso in quanto
            // filtra le scommesse parametriche dall'header nel caso in cui la mainLine non è quotata
            // o non è presente nel primo match
			// if (bet?.mainLine) {
			// 	if (bet.mainLine === bet.handicap) {
            //         return true;
            //     } else {
            //         return false;
            //     }
			// }

            if (!parametricheMap.has(bet.id)) {
                parametricheMap.add(bet.id);
                return true;
            } else {
                return false;
            }
        }
        return true;
    });
}

export function filterBetsByNumberOfOdds(bets, customCols, includeColumnBets = false) {	
	const maxColumns = customCols ? customCols: MAX_COLUMNS;
    let filteredBets = [], columnBets = [];
	let columns = 0;
	bets.forEach(bet => {
		if (bet.forceOddsListColumn || bet.compactView) {
			columnBets.push(bet);
            return;
        }

        let nOdds = bet.odds.length;
        if (bet.parametrica) {
            nOdds++;
        }
        if (columns + nOdds <= maxColumns) {
            columns += nOdds;
            filteredBets.push(bet);
        } else if (nOdds > maxColumns) {
            columnBets.push(bet);
        }
    });

    if (includeColumnBets) {
        return [filteredBets, columnBets]
    } else {
        return filteredBets;
    }
}

export function filterEntries(entries, filter, filterOn) {
	if (filter == null || filter.length === 0) {
        return entries;
	}
    const terms = filter.toLowerCase().trim().split(' ');

    return entries.filter(function(entry) {
        const entryString = filterOn(entry).toLowerCase();
        if (terms.length > 1) {
            let isMatch = false;
            for (let i = 0; i < terms.length; i++) {
                const filter = terms[i];
                if (entryString.indexOf(filter) === -1) {
                    isMatch = false;
                    break;
                } else {
                    isMatch = true;
                }
            }

            if (isMatch) {
                return entry;
            }
        } else {
            if (entryString.indexOf(terms[0]) !== -1) {
                return entry;
            }
        }
        
        return false;
    });
}

function getMatchingSubstring(string, startIndex) {
    let start = startIndex;
    while (start >= 0 && string[start] !== ' ') {
        start--;
    }
    let end = startIndex;
    while (end < string.length && string[end] !== ' ') {
        end++;
    }
    return string.substring(start + 1, end);
}

export function filterSearchResults(entries, term, type, filterOn, saveMatchingToken = false) {
	let terms = null;
	if (term != null && term.length > 0) {
		terms = term.toLowerCase().trim().split(' ');
	} else {
        return entries;
    }
    
    const isNumber = !isNaN(Number(term));
    if (isNumber && type === 'MATCH') {
        return entries.filter(entry => {
            return entry.alias != null ? entry.alias.startsWith(term): false;
        });
    } else {
        return entries.filter(entry => {
            const entryString = filterOn(entry)?.toLowerCase() ?? null;
			if (entryString == null) {
				return false;
			}
            if (terms.length > 1) {
                let isMatch = false;
                for (let i = 0; i < terms.length; i++) {
                    const term = terms[i];
                    const index = entryString.indexOf(term);
                    if (index === -1) {
                        isMatch = false;
                        break;
                    } else {
                        isMatch = true;
                        if (saveMatchingToken) {
                            entry.matchingToken = getMatchingSubstring(entryString, index);
                        }
                    }
                }
    
                if (isMatch) {
                    return entry;
                }
            } else {
                const index = entryString.indexOf(terms[0]);
                if (index !== -1) {
                    if (saveMatchingToken) {
                        entry.matchingToken = getMatchingSubstring(entryString, index);
                    }
                    return entry;
                }
            }
            
            return false;
        });
    }
}

function deepCopyOdds(odds) {
    const newOdds = [];
    for (let i = 0; i < odds.length; i++) {
        const odd = odds[i];
        // Deep copy odd
		let newOdd = {
            id: odd.id,
            desc: odd.desc,
            ranking: odd.ranking,
            value: odd.value,
            tooltip: odd.tooltip,
            tooltipByHandicap: odd.tooltipByHandicap,
            betId: odd.betId,
            aliasListDefault: odd.aliasListDefault,
            aliasByHandicap: odd.aliasByHandicap,
            aliasBySystemCode: odd.aliasBySystemCode,
            aliasHandicapBySystemCode: odd.aliasHandicapBySystemCode
        };
		if (odd.aliasByHandicap != null) {
			newOdd.aliasByHandicap = {};
			for (let kh in odd.aliasByHandicap) {
				newOdd.aliasByHandicap[kh] = odd.aliasByHandicap[kh];
			}
		}
		newOdds.push(newOdd);
    }
    return newOdds;
}

export function deepCopyBet(bet) {
    return {
        id: bet.id,
        desc: bet.desc,
        ranking: bet.ranking,
        parametrica: bet.parametrica,
        handicap: bet.handicap,
        tipoHandicap: bet.tipoHandicap,
        calculateHandicapDescription: bet.calculateHandicapDescription,
        handicapTableDesc: bet.handicapTableDesc,
        legabile: bet.legabile,
        odds: deepCopyOdds(bet.odds),
        forceAntepost: bet.forceAntepost,
        liveTimer: bet.liveTimer,
        mainLine: bet.mainLine,
        hideHandicap: bet.hideHandicap,
        handicapInfo: bet.handicapInfo,
        aggId: bet.aggId,
        aggDesc: bet.aggDesc
    };
}

export function deepCopyBetGroup(agg) {
    const bets = agg.scommesse;
    const newBets = [];
    for (let bi = 0; bi < bets.length; bi++) {
        const bet = bets[bi];
        // Deep copy bet
        newBets.push(deepCopyBet(bet));
    }
    // Deep copy bet group
    return {
        idAggregata: agg.idAggregata,
        descrizione: agg.descrizione,
        ranking: agg.ranking,
        isPrincipale: agg.isPrincipale,
        scommesse: newBets,
        compattate: agg.compattate,
        localeCmpDesc: agg.localeCmpDesc,
        sportId: agg.sportId
    }
}

function deepCopyAggs(aggsList) {
    const aggs = {};
    const keys = Object.keys(aggsList);
    let pi = 0;
    let sportId = 0;

    let i = keys.length % 8;

    while (i) {
        sportId = keys[pi++];
        aggs[sportId] = deepCopyBetGroup(aggsList[sportId]);
        i--;
    }

    i = Math.floor(keys.length / 8);

    // Process 8 per loop
    while (i) {
        sportId = keys[pi++];
        aggs[sportId] = deepCopyBetGroup(aggsList[sportId]);
        sportId = keys[pi++];
        aggs[sportId] = deepCopyBetGroup(aggsList[sportId]);
        sportId = keys[pi++];
        aggs[sportId] = deepCopyBetGroup(aggsList[sportId]);
        sportId = keys[pi++];
        aggs[sportId] = deepCopyBetGroup(aggsList[sportId]);
        sportId = keys[pi++];
        aggs[sportId] = deepCopyBetGroup(aggsList[sportId]);
        sportId = keys[pi++];
        aggs[sportId] = deepCopyBetGroup(aggsList[sportId]);
        sportId = keys[pi++];
        aggs[sportId] = deepCopyBetGroup(aggsList[sportId]);
        sportId = keys[pi++];
        aggs[sportId] = deepCopyBetGroup(aggsList[sportId]);
        i--;
    }

    return aggs;
}

const deepCopySportAggs = function(aggregate) {
    const result = {};
    const keys = Object.keys(aggregate);
    let pi = 0;
    let sportId = 0;

    let i = keys.length % 8;

    while (i) {
        sportId = keys[pi++];
        result[sportId] = deepCopyAggs(aggregate[sportId]);
        i--;
    }

    i = Math.floor(keys.length / 8);

    // Process 8 per loop
    while (i) {
        sportId = keys[pi++];
        result[sportId] = deepCopyAggs(aggregate[sportId]);
        sportId = keys[pi++];
        result[sportId] = deepCopyAggs(aggregate[sportId]);
        sportId = keys[pi++];
        result[sportId] = deepCopyAggs(aggregate[sportId]);
        sportId = keys[pi++];
        result[sportId] = deepCopyAggs(aggregate[sportId]);
        sportId = keys[pi++];
        result[sportId] = deepCopyAggs(aggregate[sportId]);
        sportId = keys[pi++];
        result[sportId] = deepCopyAggs(aggregate[sportId]);
        sportId = keys[pi++];
        result[sportId] = deepCopyAggs(aggregate[sportId]);
        sportId = keys[pi++];
        result[sportId] = deepCopyAggs(aggregate[sportId]);
        i--;
    }

    return result;
}

export function getPrematchAggs(sportId = null, aggId = null) {
    const aggsList = window.xs_ag.aggregatePrematchBySportId;
    if (sportId == null && aggId == null) {
        return deepCopySportAggs(aggsList);
    } else if (aggId == null) {
        return deepCopyAggs(aggsList[sportId]);
    } else {
        const agg = aggsList[sportId][aggId];
        return agg != null ? deepCopyBetGroup(agg): null;
    }
}

export function getLiveAggs(sportId = null, aggId = null) {
    const aggsList = window.xs_ag.aggregateLiveByIdSport;
    if (sportId == null && aggId == null) {
        return deepCopySportAggs(aggsList);
    } else if (aggId == null) {
        return deepCopyAggs(aggsList[sportId]);
    } else {
        const agg = aggsList[sportId][aggId];
        return agg != null ? deepCopyBetGroup(agg): null;
    }
}

let configuration = null;
function getConfigurationSourceCode() {
	configuration = JSON.parse(localStorage.getItem('xs_configuration'));
    setApiDomain(configuration);
    
    if (configuration && window.appConfig && window.appConfig.SHOP_MODE) {
        // deactivate all the online functionalities by default
        configuration.bwe = false;
		configuration.lme = false;
        configuration.tme = false;
        configuration.cre = false;
        configuration.bse = false;
        configuration.lwe = false;
        configuration.tfs = true;
        configuration.anbe = false;
        configuration.mybbp = false;
        configuration.frbe = false;
		configuration.bfs = {
			maxw :0,
			fms: []
		};
    }
	if(window.appConfig?.TERMINAL_AGENCY){
		//configuration.cwe = false;
	}
	if (window.appConfig?.XSHOP_TERMINAL) {
		configuration.bco = ['multibets', 'systembets'];
	}

    if (window.seoConfig && configuration) {
        configuration.seo = window.seoConfig;
    }

	if (configuration && configuration.gdprscc) {
		try {
			configuration.gdprscc = JSON.parse(configuration.gdprscc);
		}catch(err) {
			console.error(err);
		}
	}

    if (configuration) {
		// override function, in order to return forever the calculated configuration object 
    	getConfiguration = () => configuration;
	}
	else{
		return configuration;
	}
	
	return getConfiguration();
}

export let getConfiguration = function() {
    return getConfigurationSourceCode();
}

export function resetConfiguration() {
	configuration = null;
	// restoring the original function, in order to be sure that the function will calculate the new configuration with the original source code
	getConfiguration = () => {
		return getConfigurationSourceCode();
	}
}


export function getConfigurationForPrinterSocket() {
	const conf = getConfiguration();
	const json = {
		nas: conf.nas,
		cs: conf.cs,
		qrct: conf.qrct,
		dbutc: conf.dbutc,
		tof: getTimezoneOffset(),
		dft: conf.dft,
		plit: conf.plit,
		skta: conf.skta,
		tad: conf.tad,
		ppat: conf.ppat,
		logoBitmap: conf.logoBitmap,
		rs: conf.rs,
		lbls: {}
	};
	json.lbls['printer.plain_ticket.footer.bet_amount'] = getLabel('printer.plain_ticket.footer.bet_amount');
	json.lbls['printer.plain_ticket.footer.bonus'] = getLabel('printer.plain_ticket.footer.bonus');
	json.lbls['printer.plain_ticket.footer.bonus_type'] = getLabel('printer.plain_ticket.footer.bonus_type');
	json.lbls['printer.plain_ticket.footer.combs'] = getLabel('printer.plain_ticket.footer.combs');
	json.lbls['printer.plain_ticket.footer.gross_winnings'] = getLabel('printer.plain_ticket.footer.gross_winnings');
	json.lbls['printer.plain_ticket.footer.max_winnings'] = getLabel('printer.plain_ticket.footer.max_winnings');
	json.lbls['printer.plain_ticket.footer.min_winnings'] = getLabel('printer.plain_ticket.footer.min_winnings');
	json.lbls['printer.plain_ticket.footer.potential_winnings'] = getLabel('printer.plain_ticket.footer.potential_winnings');
	json.lbls['printer.plain_ticket.footer.system_total_amount'] = getLabel('printer.plain_ticket.footer.system_total_amount');
	json.lbls['printer.plain_ticket.footer.tax'] = getLabel('printer.plain_ticket.footer.tax');
	json.lbls['printer.plain_ticket.footer.tax'] = getLabel('printer.plain_ticket.footer.tax');
	json.lbls['printer.plain_ticket.footer.total_amount'] = getLabel('printer.plain_ticket.footer.total_amount');
	json.lbls['printer.plain_ticket.footer.total_combs'] = getLabel('printer.plain_ticket.footer.total_combs');
	json.lbls['printer.plain_ticket.footer.total_odds'] = getLabel('printer.plain_ticket.footer.total_odds');
	json.lbls['printer.plain_ticket.footer.total_potential_winnings'] = getLabel('printer.plain_ticket.footer.total_potential_winnings');
	json.lbls['printer.plain_ticket.footer.total_winnings'] = getLabel('printer.plain_ticket.footer.total_winnings');
	json.lbls['printer.plain_ticket.footer.max_winning_amount'] = getLabel('printer.plain_ticket.footer.max_winning_amount');
	json.lbls['printer.plain_ticket.footer.type'] = getLabel('printer.plain_ticket.footer.type');
	json.lbls['printer.plain_ticket.footer.winnings_limit'] = getLabel('printer.plain_ticket.footer.winnings_limit');
	json.lbls['printer.plain_ticket.header.agency'] = getLabel('printer.plain_ticket.header.agency');
	json.lbls['printer.plain_ticket.header.cc'] = getLabel('printer.plain_ticket.header.cc');
	json.lbls['printer.plain_ticket.header.cf'] = getLabel('printer.plain_ticket.header.cf');
	json.lbls['printer.plain_ticket.header.copy'] = getLabel('printer.plain_ticket.header.copy');
	json.lbls['printer.plain_ticket.header.fixed_odds'] = getLabel('printer.plain_ticket.header.fixed_odds');
	json.lbls['printer.plain_ticket.header.ge'] = getLabel('printer.plain_ticket.header.ge');
	json.lbls['printer.plain_ticket.header.gr'] = getLabel('printer.plain_ticket.header.gr');
	json.lbls['printer.plain_ticket.header.id'] = getLabel('printer.plain_ticket.header.id');
	json.lbls['printer.plain_ticket.header.multiple_bets'] = getLabel('printer.plain_ticket.header.multiple_bets');
	json.lbls['printer.plain_ticket.header.nc'] = getLabel('printer.plain_ticket.header.nc');
	json.lbls['printer.plain_ticket.header.oe'] = getLabel('printer.plain_ticket.header.oe');
	json.lbls['printer.plain_ticket.header.operator'] = getLabel('printer.plain_ticket.header.operator');
	json.lbls['printer.plain_ticket.header.pv'] = getLabel('printer.plain_ticket.header.pv');
	json.lbls['printer.plain_ticket.header.single_bets'] = getLabel('printer.plain_ticket.header.single_bets');
	json.lbls['printer.plain_ticket.header.system_bets'] = getLabel('printer.plain_ticket.header.system_bets');
	json.lbls['printer.plain_ticket.header.tg'] = getLabel('printer.plain_ticket.header.tg');
	json.lbls['printer.plain_ticket.header.tm'] = getLabel('printer.plain_ticket.header.tm');
	json.lbls['printer.plain_ticket.tuples.activate_bonus'] = getLabel('printer.plain_ticket.tuples.activate_bonus');
	json.lbls['printer.plain_ticket.tuples.bet_amount'] = getLabel('printer.plain_ticket.tuples.bet_amount');
	json.lbls['printer.plain_ticket.tuples.combs'] = getLabel('printer.plain_ticket.tuples.combs');
	json.lbls['printer.plain_ticket.tuples.fixed'] = getLabel('printer.plain_ticket.tuples.fixed');
	json.lbls['printer.plain_ticket.tuples.max_winnings'] = getLabel('printer.plain_ticket.tuples.max_winnings');
	json.lbls['printer.plain_ticket.tuples.min_winnings'] = getLabel('printer.plain_ticket.tuples.min_winnings');
	json.lbls['printer.plain_ticket.tuples.type'] = getLabel('printer.plain_ticket.tuples.type');
	json.lbls['printer.plain_ticket.tuples.variable'] = getLabel('printer.plain_ticket.tuples.variable');
	json.lbls['ticket.system.base_symb'] = getLabel('ticket.system.base_symb');
	json.lbls['ticket.system.var_symb'] = getLabel('ticket.system.var_symb');
	json.lbls['ticket.system.base'] = getLabel('ticket.system.base');
	json.lbls['ticket.system.variable'] = getLabel('ticket.system.variable');
	json.lbls['ticket.system.in_bonus'] = getLabel('ticket.system.in_bonus');
	json.lbls['general.live'] = getLabel('general.live');
	json.lbls['retail.voucher_receipt_title'] = getLabel('retail.voucher_receipt_title');
	json.lbls['retail.date_time'] = getLabel('retail.date_time');
	json.lbls['retail.voucher_to_get'] = getLabel('retail.voucher_to_get');
	json.lbls['retail.voucher.id'] = getLabel('retail.voucher.id');
	json.lbls['retail.receipt_disclaimer'] = getLabel('retail.receipt_disclaimer');
	json.lbls['retail.transactions_log'] = getLabel('retail.transactions_log');
	json.lbls['retail.picking_report_receipt'] = getLabel('retail.picking_report_receipt');
	json.lbls['retail.shop_pvend'] = getLabel('retail.shop_pvend');
	json.lbls['retail.terminal_number'] = getLabel('retail.terminal_number');
	json.lbls['retail.printer.printer_error'] = getLabel('retail.printer.printer_error');
	json.lbls['retail.printer.cover_open'] = getLabel('retail.printer.cover_open');
	json.lbls['retail.printer.paper_out'] = getLabel('retail.printer.paper_out');
	json.lbls['retail.printer.jam_detected'] = getLabel('retail.printer.jam_detected');
	json.lbls['retail.printer.cutter_faulted'] = getLabel('retail.printer.cutter_faulted');
	json.lbls['retail.printer.serious_error'] = getLabel('retail.printer.serious_error');
	json.lbls['retail.printer.paper_too_low'] = getLabel('retail.printer.paper_too_low');
	json.lbls['retail.printer.paper_low'] = getLabel('retail.printer.paper_low');
	json.lbls['retail.account_recharge.recharge_receipt'] = getLabel('retail.account_recharge.recharge_receipt');
	json.lbls['retail.account_recharge.account_num'] = getLabel('retail.account_recharge.account_num');
	json.lbls['retail.account_recharge.title'] = getLabel('retail.account_recharge.title');
	json.lbls['general.timestamp'] = getLabel('general.timestamp');
	json.lbls['retail.account_recharge.transaction_log'] = getLabel('retail.account_recharge.transaction_log');
	json.lbls['retail.from'] = getLabel('retail.from');
	json.lbls['retail.to'] = getLabel('retail.to');
	json.lbls['general.quantity'] = getLabel('general.quantity');
	json.lbls['retail.account_recharge.transactions_total'] = getLabel('retail.account_recharge.transactions_total');
	json.lbls['retail.amount'] = getLabel('retail.amount');
	
	return json;
}

let tmcv = null;
export function getTmcv() {
	if (tmcv == null) {
		tmcv = localStorage.getItem('xs_tmcv');
	}
	return tmcv;
}

function setApiDomain(configuration) {
	const apiDomain = getEnv('REACT_APP_API_DOMAIN');

	apiDomain && configuration &&  configuration.api && 
	Object.keys(configuration.api).forEach(function(k) {
		
		if (window.appConfig && window.appConfig.IS_LOCALHOST) {
			const values = configuration.api[k].split("/");
			if (values.length >= 2) {
				values[1] = 'XSportDatastore'; // replacing XSportDatastoreMagnum
				configuration.api[k] = values.join('/');
			}
		}
		const v = configuration.api[k];
		const isSocketUrl = v.startsWith('ws:') || v.startsWith("wss:");
		if (!isSocketUrl && (!v.match(/(https?:\/\/.*):(\d*)\/?(.*)/g))) {
			configuration.api[k] = apiDomain+v;
		}
	})
	
}

export function getUrlToFetch(url) {
	const apiDomain = getEnv('REACT_APP_API_DOMAIN');

	try {
		if(new URL (window.location.origin)?.hostname?.startsWith("localhost") && apiDomain && !url.startsWith(apiDomain)) {
			return concatUrlPathnames(apiDomain,url);
		}else{
			return url;
		}
	}catch(err) {
		return url;
	}
}

export function getLocalhostLocatiohHref(){
	let locationHref ;

	try {
		
		if(window.location.href.startsWith("http://localhost:")){
			let part = window.location.href.substring('http://localhost:'.length);
			const port = part.substring(0,part.indexOf('/'));
      locationHref = 'http://localhost:'+port;
		}

	}catch(err){
		console.error(err);
	}
	
	return locationHref;
}

export function getToolTipDesc(odd) {
	let tooltip = '';
	
    if (odd.betData) {
    	let tooltipSource = odd.tooltip;
    	if (odd.tooltipByHandicap && odd.tooltipByHandicap['' + odd.betData.handicap]) {
    		tooltipSource = odd.tooltipByHandicap['' + odd.betData.handicap];
    	}
        if (tooltipSource) {
            tooltip = tooltipSource.replaceAll('{{TEAM1}}', odd.team1).replaceAll('{{TEAM2}}', odd.team2);
        } else {
            const dia = odd.betData.dia?.dia ?? null;
            if (dia != null) {
                const betDesc =  `${odd.betData.desc} (${dia})`;
                tooltip = `${betDesc}: ${odd.desc}`;
            }

        }

        if (tooltip.length > 0 && odd.betData.handicap !== '0' && odd.betData.tipoHandicap !== 7) {
            let hcp = odd.betData.handicap;
            if (isAsianHandicap(odd.betData.id) && odd.id === 2) {
                hcp *= -1;
            }
			const conf = getConfiguration();
            const setHandicap = conf.sht || tooltip.indexOf("{{") >= 0 || tooltip.indexOf("@@") >= 0;
            if(setHandicap){
            	// ho aggiunto questo controllo perche' altrimenti capitavamo nella situazione in cui
            	// sia l'handicap che la traduzione dell'handicap venivano mostrati:
            	// es -> U/O 2.5   usciva   Ci saranno più di 2 goal 2.5
            	// quindi entro in questo if se il cliente vuole da configurazione specificare l'handicap (sht)
            	// oppure se dal cms è stato comunque impostato il marcatore {{Hx}}, potrebbero sempre volerlo specificare
            	// anche in una scommessa specifica
            	
				tooltip = parseHandicap(tooltip, hcp, odd.betData.tipoHandicap, null, odd.betData.dia);
			}

        }
	}
    
	return tooltip;
}

export function getLocaleDotRound() {
	const num = 1000.5;
	try {
		const string = num.toLocaleString(); // 1.000,5
		// mi aspetto una stringa di 7 caratteri: se non la ottengo significa che nel browser
		// il punto delle migliaia non viene usato, allora restituisco quelle di default
		if (string.length === 7) {
			return {
				dot: string[1],
				round: string[5]
			}					
		}
	} catch(e) {
        console.error(e);
    }

	return {
		dot:'.',
		round: ','
	}
}

export function getMobileIncrementValues(user, cutFirst){
	if(!user){
		user = {logged:false};
	}
	let incrementValues = [-1, -5, 5, 1];
	const conf = getConfiguration();
	if(conf.bak.mob){
		let candidateArray = null;
		const type = conf.bak.type;
		//const type = "USER_SUGGESTION";
		if(type === 'USER_SUGGESTION' && user.logged && user.lastTickets.length > 0){
			const firstAmount = user.lastTickets[0].amount;
			candidateArray = [];
			candidateArray.push(firstAmount);
			candidateArray.push(firstAmount * 100);
			candidateArray.push(firstAmount * 300);
			candidateArray.push(firstAmount * 500);
		}
		else if((!type || type === 'DEFAULT' || !user.logged || user.lastTickets?.length === 0) && conf.bak.vls?.length > 0){
			candidateArray = conf.bak.vls;
		}
		if(candidateArray){
			incrementValues = [];
			for(let kv in candidateArray){
				let integerValue = candidateArray[kv];
				integerValue = getPrintableAmount(integerValue, conf.cs.m, conf.cs.nd);
				const comma = getLocaleDotRound().round;
				const dot = getLocaleDotRound().dot;
				integerValue = integerValue.replaceAll(dot, '');
				integerValue = parseInt(integerValue.split(comma)[0], 10);
				incrementValues.push(integerValue);
			}			
		}
	}	
	if(cutFirst){
		incrementValues.shift();
	}
	return incrementValues;
}

export function getCurrencyValue(amount, multiplier, decimals, currency) {
	let ln = getPrintableAmount(amount, multiplier, decimals);
    currency = getCurrencySymbol(currency);
	return systemCode === 'SUREBET' ?  `${currency} ${ln} ` : `${ln} ${currency}`;
}

export function getCurrencySymbol(currency) {
	if(!currency){
		const conf = getConfiguration();
		currency = conf.cs.ct;
	}
	let symbol = currency;
	let htmlCode = null;
	if (currency.toUpperCase().trim() === 'EUR') {
		htmlCode = '&euro;';
	}
	else if (currency.toUpperCase().trim() === 'TND') {
		htmlCode = 'DT';
	}
	else if (currency.toUpperCase().trim() === 'NGN') {
		htmlCode = '&#8358;';
	}
	else if (currency.toUpperCase().trim() === 'USD') {
		htmlCode = '&#36;';
	}
	else if (currency.toUpperCase().trim() === 'BGR') {
		htmlCode = '&#1083;&#1074;';
	}
	else if (currency.toUpperCase().trim() === 'BGN') {
		htmlCode = '&#1083;&#1074;';
	}
	if (htmlCode != null) {
		let span = document.createElement('span');
		span.innerHTML = htmlCode;
		if (span.textContent.length > 0) {
			symbol = span.textContent;
		}
	}
	return symbol;
}

export function isCoinAmount(amount) {
	return amount == 50 || amount == 100 || amount == 200;
}

export function getPrintableAmount(amount, multiplier, decimals) {
	const n = parseFloat(amount / multiplier);
	// formatto la stringa in base al locale attuale
	let ln = n.toLocaleString();
	// acquisisco il carattere della virgola utilizzato per il locale del paese
	const round = getLocaleDotRound().round;

	if (ln.indexOf(round) < 0) {
		// non c'è la virgola, aggiungo virgola + decimals decimali
		if (decimals > 0) {
			ln += round;
			for (let i = 0; i < decimals; i++) {
				ln += '0';				
			}			
		}
	} else {
		// c'è gia la virgola, aggiungo i numeri decimali mancanti
		const zeroMancanti = decimals - ln.split(round)[1].length;
		for (let i = 0; i < zeroMancanti; i++) {
			ln += '0';
		}
	}	
    
    return `${ln}`;
}

export function getNumberOfCols(odds) {
    const oddsLength = odds.length;
    return oddsLength > 2 && oddsLength <= 5 ? oddsLength: 2;
}

export function getNumberOfColsDesktop(length) {
    if (length === 2 || length === 3) {
        return length;
    } else if (length > MAX_COLUMNS) {
        return 2;
    } else if (length % 3 === 0) {
        return  3;
    } else if (length % 2 === 0) {
        return 2;
    } else {
        return 2;
    }
}

export function getNumberOfColsMobile(length) {
    if (length >= 1 && length <= 3) {
        return length;
    } else if (length > MAX_COLUMNS) {
        return 1;
    } else if (length % 2 === 0) {
        return 2;
    } else {
        return 1;
    }
}

export function getBetDescriptionBetSelector(bet, genericReplace) {
    const desc = bet.descNoHandicap || bet.desc;
    if (bet.parametrica && genericReplace) {
        return desc.replace('@@H1@@', 'x')
                   .replace('@@H2@@', 'x')
                   .replace('@@H3@@', 'x')
                   .replace('@@H4@@', 'x')
                   .replace('@@H5@@', 'x')
                   .replace('@@H6@@', 'x')
                   .replace('@@H7@@', 'x')
                   .replace('@@H8@@', 'x');
    }else {
        return desc;
    }
}


export function aggregateBetsForPlayer(bets, infoAgg) {
	const auxMap = {};
	for (let kb in bets) {
		const bet = bets[kb];
		const handicapSplitted = splitHandicap(bet.handicap, infoAgg, null, xs_languageCode);
		// se ci sono due anagrafiche, invece di indicizzare per il singolo giocatore, indicizzo per la coppia di giocatori
		const playerId = handicapSplitted.idAnagrafica + (handicapSplitted.idAnagrafica2 !== null? "_" + handicapSplitted.idAnagrafica2 : "");
		if (!auxMap[playerId]) {
			auxMap[playerId] = JSON.parse(JSON.stringify(bet));
			auxMap[playerId].odds = [];
		}
		let dia = bet.dia? bet.dia : "";
		if(dia.indexOf('$') >= 0){
			
			const idAnag1 = dia.split('$')[0];
			const idAnag2 = dia.split('$')[1];
			// l'info aggiuntiva può essere presentata almeno in 3 modi diversi all'interno della descrizione impostata da CMS. Capisco qual è, in modo da isolare il resto della descrizione della scommessa (che va nella parte destra del box handicap)
			const chanches = {
				' + ' : idAnag1 + " + " + idAnag2,
				' / ' : idAnag1 + " / " + idAnag2,
				' ' : idAnag1 + " " + idAnag2,
				' oppure ' : idAnag1 + " oppure " + idAnag2,
				' o ' : idAnag1 + " oppure " + idAnag2,
			};
			
			let found = false;
			for(let k in chanches){
				const contained = chanches[k];
				if(bet.desc.indexOf(contained) >= 0 ) {
					dia = contained;
					found = true;
				}
			}
			if(!found){
				dia = dia.replace('$', ' '); // caso default
			}
		}
		const descDrawRadix = bet.desc.indexOf(dia) >= 0? bet.desc.split(dia)[1]: bet.desc;
		auxMap[playerId].desc = dia;
		for (let ko in bet.odds) {
			const odd = JSON.parse(JSON.stringify(bet.odds[ko]));
			let descForBetsAggregate = descDrawRadix;
			if (descForBetsAggregate.startsWith(' ')) {
				descForBetsAggregate = descForBetsAggregate.substring(1);
			}

            if (bet.odds.length > 1) {
				descForBetsAggregate = `${descForBetsAggregate} - ${odd.desc}`;
				// escludo i casi in cui siamo con due giocatori. Nel caso di (esempio) tipo handicap 37, la parte sinistra dell'handicap sarà composta da 2 giocatori
				if(handicapSplitted.idAnagrafica2 === null){
	                descForBetsAggregate = parseHandicap(descForBetsAggregate, bet.handicap, bet.tipoHandicap, bet.eqs, dia, false);				
				}
			}
            
            odd.descForBetsAggregate = descForBetsAggregate;
			auxMap[playerId].odds.push(odd);
			auxMap[playerId].dia = dia;
		}
	}
	const finalArray = [];
	for (let k in auxMap) {
		finalArray.push(auxMap[k]);
	}
	return finalArray;
}



export function getOccurrenceOfMarket(referenceBetId, betArray){
   	let occurrenceOfThisMarket = 0;
	for(let kb in betArray){
		const otherOccurrence = betArray[kb];
		const betId = otherOccurrence.cs || otherOccurrence.id;
		if(betId == referenceBetId){
			occurrenceOfThisMarket ++;
		}
	}
	return occurrenceOfThisMarket;
}

export function getGenericHandicapDescriptionPart(betId, handicap, position){
	const map = {
		1 : "x",
		2 : "y",
		3 : "z",
		4 : "k",
		5 : "w",
		6 : "j",
		7 : "t",
		8 : "h"
	}
	return map[position];
}

export function getBetDescription(bet, genericReplace, sportId, otherBetsArray) {
    //const desc = bet.desc != null ? bet.desc: '';
   	const occurrenceOfThisMarket = otherBetsArray? getOccurrenceOfMarket(bet.cs || bet.id, otherBetsArray): null;
   	let desc = bet.desc || bet.rds;
   	if(!desc){
   		desc = "";
   	}
	let parametrica = bet.parametrica;
	let calculateHandicapDescription = bet.calculateHandicapDescription;
	let tipoHandicap = bet.tipoHandicap;
	const betId = bet.cs || bet.id;
	const handicap = bet.h || bet.handicap;
    const aggregateContainer = sportId? 
    getAggregationAndBetFromBetIdAndSportId(sportId, betId, handicap) :
    getAggregationAndBetFromBetId(betId, handicap);
    // getting the native description of this market
    if (aggregateContainer && aggregateContainer.market) {
    	tipoHandicap = aggregateContainer.market.tipoHandicap;
		desc = aggregateContainer.market.desc;
		parametrica = aggregateContainer.market.parametrica;
		calculateHandicapDescription = aggregateContainer.market.calculateHandicapDescription;
		if (aggregateContainer.aggregation?.compattate) {
			for (let descComp in aggregateContainer.aggregation.compattate) {
				const compactedBets = aggregateContainer.aggregation.compattate[descComp];
				for (let kc in compactedBets) {
					if (compactedBets[kc] === (bet.cs + "_" + bet.h)) {
						desc = descComp;
						if (aggregateContainer.aggregation.localeCmpDesc && 
                            aggregateContainer.aggregation.localeCmpDesc[descComp] && 
                            aggregateContainer.aggregation.localeCmpDesc[descComp][xs_languageCode] != null) {
                            desc =  aggregateContainer.aggregation.localeCmpDesc[descComp][xs_languageCode];
						}
					}
				}
			}
		}
    }
    const itIsTheOnlyHandicapLineForThisEvent = occurrenceOfThisMarket && occurrenceOfThisMarket == 1;
    const containsHandicapPlaceholder = desc.indexOf("@@H") >= 0 || desc.indexOf("{{H") >= 0;
    const uselessHandicapParsing = itIsTheOnlyHandicapLineForThisEvent && !containsHandicapPlaceholder;
    if (calculateHandicapDescription && genericReplace) {	
       desc = desc.replaceAll('@@H1@@', getGenericHandicapDescriptionPart(betId, handicap, 1))
                   .replaceAll('@@H2@@', getGenericHandicapDescriptionPart(betId, handicap, 2))
                   .replaceAll('@@H3@@', getGenericHandicapDescriptionPart(betId, handicap, 3))
                   .replaceAll('@@H4@@', getGenericHandicapDescriptionPart(betId, handicap, 4))
                   .replaceAll('@@H5@@', getGenericHandicapDescriptionPart(betId, handicap, 5))
                   .replaceAll('@@H6@@', getGenericHandicapDescriptionPart(betId, handicap, 6))
                   .replaceAll('@@H7@@', getGenericHandicapDescriptionPart(betId, handicap, 7))
                   .replaceAll('@@H8@@', getGenericHandicapDescriptionPart(betId, handicap, 8))
                   .replaceAll('{{H1}}', getGenericHandicapDescriptionPart(betId, handicap, 1))
                   .replaceAll('{{H2}}', getGenericHandicapDescriptionPart(betId, handicap, 2))
                   .replaceAll('{{H3}}', getGenericHandicapDescriptionPart(betId, handicap, 3))
                   .replaceAll('{{H4}}', getGenericHandicapDescriptionPart(betId, handicap, 4))
                   .replaceAll('{{H5}}', getGenericHandicapDescriptionPart(betId, handicap, 5))
                   .replaceAll('{{H6}}', getGenericHandicapDescriptionPart(betId, handicap, 6))
                   .replaceAll('{{H7}}', getGenericHandicapDescriptionPart(betId, handicap, 7))
                   .replaceAll('{{H8}}', getGenericHandicapDescriptionPart(betId, handicap, 8));
    	return desc;
    } else if ((calculateHandicapDescription) && (!uselessHandicapParsing)) {
        let handicap = bet.handicap != null? bet.handicap: 0;
    	if (bet.h != null && (!handicap || handicap == 0)) {
            handicap = bet.h;
    	}
        
        return parseHandicap(desc, handicap, tipoHandicap, bet.eqs || bet.odds, bet.dia || bet.odds?.[0]?.dia, false, bet.handicapInfo);
    } else {
        return desc;
    }
}

export function positionPopupSearchBox(inputElement, popupSearchBox) {
    popupSearchBox.style.visibility = 'hidden';
    popupSearchBox.classList.remove('d-none');

    let inputElementTop = inputElement.getBoundingClientRect().top;
    let inputElementHeight = inputElement.getBoundingClientRect().height;
    let inputElementLeft = inputElement.getBoundingClientRect().left;
    let inputElementRight = inputElement.getBoundingClientRect().right;

    let popupSearchBoxTop = inputElementTop + inputElementHeight + 2;
    let popupSearchBoxLeft = inputElementLeft;

    popupSearchBox.style.top = `${popupSearchBoxTop}px`;
    popupSearchBox.style.left = `${popupSearchBoxLeft}px`;

    let popupSearchBoxRight = popupSearchBox.getBoundingClientRect().right;
    let bodyRight = document.getElementsByTagName('body')[0].getBoundingClientRect().right;

    if (popupSearchBoxRight > bodyRight) {
        popupSearchBox.style.left = 'unset';
        popupSearchBox.style.right = `${bodyRight - inputElementRight}px`;

    }
	popupSearchBox.style.maxHeight = `calc(100vh - ${popupSearchBoxTop}px)`;
    popupSearchBox.style.visibility = 'visible';
}

export function positionPopupSearchBoxFastbet(inputElement, popupSearchBox) {
    popupSearchBox.style.visibility = 'hidden';
    popupSearchBox.classList.remove('d-none');
    let inputElementTop = inputElement.getBoundingClientRect().top;
    let popupSearchBoxTop = inputElementTop;
    popupSearchBox.style.top = '55px';
	popupSearchBox.style.maxHeight = `calc(100vh - ${popupSearchBoxTop}px)`;
    popupSearchBox.style.visibility = 'visible';
}

export function toggleFavouriteMatchInStorage(matchUniqueId, match, idAggregata) {
	const favouritesLocalStorage = JSON.parse(localStorage.getItem('x_fav_mtchs') || '{}');
    if (favouritesLocalStorage[matchUniqueId] !== undefined) {
    	delete favouritesLocalStorage[matchUniqueId];
    } else {
		favouritesLocalStorage[matchUniqueId] = {...match, idAggregata};
	}
    localStorage.setItem('x_fav_mtchs',JSON.stringify(favouritesLocalStorage));

}

export function isFavouriteMatchInStorage(matchUniqueId) {
	const favouritesLocalStorage = JSON.parse(localStorage.getItem('x_fav_mtchs') || '{}');
	return favouritesLocalStorage[matchUniqueId] !== undefined;
}

export function getFavouriteMatchesFromStorage() {
	return JSON.parse(localStorage.getItem('x_fav_mtchs') || '{}');
}

export function truncateToDecimal(figure, decimals) {
	  if (decimals === undefined) {
		  let conf = getConfiguration();
		  decimals = conf.cs.nd;
	  }
	  let d = Math.pow(10,decimals);
	  return (parseInt(figure*d, 10)/d).toFixed(decimals);
}


export function convertToDecimalWithPrecision(number, precision, scale){
	/*const power = Math.pow(10, precision);
	return (parseInt(number*power)/power).toFixed(precision);*/
	const numberWithPrecision = new Number(number).toPrecision(precision);
	return new Number(numberWithPrecision).toFixed(scale);
}

export function roundNumber(value, precisionPar) {
	let conf = getConfiguration();
	if (conf.nas) {
		if (conf.cs.crm == 2) {
			value = Math.trunc(value);			
		}
		else{
			const result = truncateToDecimal(value, precisionPar);
			return parseFloat(result);
		}
	}
    let precision = precisionPar || 0,
    power = Math.pow(10, precision),
    absValue = Math.abs(Math.round(value * power)),
    result = (value < 0 ? '-': '') + String(Math.floor(absValue / power));

    if (precision > 0) {
        var fraction = String(absValue % power),
            padding = new Array(Math.max(precision - fraction.length, 0) + 1).join('0');
        result += '.' + padding + fraction;
    }
    return parseFloat(result);
}

export function roundForCurrency(amount) {
	const conf = getConfiguration();
	const coinRoundMode = conf.cs.crm;
	const nDec = conf.cs.nd;
	if(conf.nas && coinRoundMode != 0){
		if(coinRoundMode === 1){
			const minimumCoinAmount = conf.cs.imu;
			let minus = amount;
			let maior = amount;
			while((minus % minimumCoinAmount != 0) && (minus % minimumCoinAmount != minus)) {
				minus --;
			}
			
			while((maior % minimumCoinAmount != 0) && (maior % minimumCoinAmount != maior)) {
				maior ++;
			}
			
			if (minus == 0 && maior == 0) {
				return amount;
			}
			if (minus == 0 && maior > 0) {
				return maior;
			}
			if (minus > 0 && maior == 0) {
				return minus;
			}
			
			if (amount - minus >= maior - amount) {
				return maior;
			}
			else{
				return minus;
			}		
		}
		else if(coinRoundMode === 2){
			return Math.trunc(amount);
		}
	}
	else {
		// truncate to the nDec decimal part
		const parts = (parseFloat(amount) + "").split('.');
		const natural = parts[0];
		let decimal = parts[1];
		if(!decimal){
			decimal = "00";
		}
		if(nDec === 0){
			return parseFloat(natural);
		}
		if(decimal){
			return parseFloat(natural + "." + decimal.substring(0,nDec));	
		}
	}
}

export function getPotentialWinning(amount, odd, nDec) {
	let potWin = parseFloat(odd * amount);
	potWin = truncateToDecimal(potWin, 6);
	potWin = parseFloat(roundNumber(potWin, nDec));
	potWin = roundForCurrency(potWin);
	return potWin;
}


export function printableNumber(num) {
	
	let n = parseFloat(num);
	// formatto la stringa in base al locale attuale
	let ln = n.toLocaleString();
	// quanti numeri dopo la virgola devo impostare?
	let conf = getConfiguration();
	let n_dec = conf.cs.nd;
	// acquisisco il carattere della virgola utilizzato per il locale del paese
	let round = getLocaleDotRound().round;

	if (ln.indexOf(round) < 0) {
		// non c'e' la virgola, aggiungo  virgola + n_dec decimali
		if (n_dec > 0) {
			ln += round;
			for (let i = 0; i < n_dec; i++) {
				ln+="0";				
			}			
		}
	}
	else{
		// c'e' gia la virgola, aggiungo i numeri decimali mancanti
		let zeroMancanti = n_dec - ln.split(round)[1].length;
		for (let i = 0; i < zeroMancanti; i++) {
			ln+="0";
		}
	}	
	return ln;
	
}

export function showTooltip(oddContainer, desc, tooltipPosition = 'top') {
    if (oddContainer == null || desc == null || desc.length === 0) {
        return;
    }

    // Create tooltip container, if needed
    let tooltip = document.getElementById('tooltipContainer_Template001');
    if (tooltip == null) {
        tooltip = document.createElement('div');
        tooltip.setAttribute('id', 'tooltipContainer_Template001');
        tooltip.innerHTML = '<p></p>';
        document.getElementsByTagName('body')[0].appendChild(tooltip);
    }
	
    const oddContainerRect = oddContainer.getBoundingClientRect();
    const left = oddContainerRect.left + ((oddContainerRect.right - oddContainerRect.left) / 2);
	if(tooltip === 'top'){
		const top = oddContainerRect.top - document.body.getBoundingClientRect().top;
		tooltip.style.top = `${top}px`;
	} else {
		const top = oddContainerRect.top + oddContainerRect.height;
		tooltip.style.top = `${top}px`;
		tooltip.classList.add('tooltipBottom');
	}
    tooltip.style.left = `${left}px`;
    tooltip.getElementsByTagName('p')[0].innerText = desc;
    tooltip.style.display = 'flex';
}

export function hideTooltip() {
	const element = document.getElementById("tooltipContainer_Template001");
	if (element != null) {
		element.style.display = 'none';		
	}
}

export function handleMouseOverTooltip(e) {
    const el = e.currentTarget;
	console.log(el.getBoundingClientRect().top)
	let tooltipPosition = 'top';

	if (el.getBoundingClientRect().top < 50) {
		tooltipPosition = 'bottom';
	}
    const desc = el.getAttribute('data-desc');
    showTooltip(el, desc, tooltipPosition);
}

// return a valid amount string: remove the multiple "dots" and the invalid chars
export function getValidAmountString(amount, nDec) {
	amount = amount + "";
	if(amount.indexOf(".") > 0){
		const digitAfterDot = amount.split(".")[1];
		if(digitAfterDot?.length === 3){
			// togliamo il punto delle migliaia, perche' viene visto come float ES: 1.000 -> 1,00
			amount = amount.replaceAll(".", "");
		} 
	}
	let decimalChar = '.'; // the one used in for the type "float"
	amount = amount.replace(/,/g, decimalChar); // replace all the comma with the default decimalChar
	let numberOfDecimalCharAdmitted = nDec == 0? 0:1;
	let lastIndexOf = amount.lastIndexOf(decimalChar);
	let firstIndexOf = amount.indexOf(decimalChar);
	let removeLastDigit = false;
	if (numberOfDecimalCharAdmitted == 0) {
		if (lastIndexOf >= 0 || firstIndexOf >= 0) {
			// last digit is a "."; remove it. No decimal number are permitted in this system
			removeLastDigit = true;			
		}
	}
	else{
		if (lastIndexOf != firstIndexOf) {
			// last digit is a "."; remove it because there is already a "."
			removeLastDigit = true;
		}
		else{
			let values = amount.split(decimalChar);
			if (values.length === 2) {
				let decimals = values[1];
				if (decimals.length > nDec) {
					// avoid decimals > max decimal handled in this system
					removeLastDigit = true;
				}
			}
		}
	}
	// only number and dots
	let reg = new RegExp("^[0-9.]*$");
	if (reg.test(amount) === false) {
		// last digit is a unaceptable char; remove it
		removeLastDigit = true;
	}
	
	
	
	if (removeLastDigit) {
		amount = amount.substr(0, amount.length - 1);	
	}
	return amount;
}

export function getOddsInCent(odd) {
	let oddString = odd + "";
	let natural = 0;
	let decimal = 0;
	let divChar = "";
	let oddCent = 0;
	if (oddString.indexOf('.') > 0) {
		divChar = ".";
	}
	else if (oddString.indexOf(',') > 0) {
		divChar = ",";
	}
	natural = oddString.split(divChar)[0];
	decimal = oddString.split(divChar)[1];
	if (decimal == null) {
		oddCent = natural;
	}
	else{
		if (decimal.length === 1) {
			decimal = decimal + "0";
		}
		oddCent = natural + decimal;
	}
	

	return parseInt(oddCent, 10);
}

export function getSelectionsFromBetWidget(coupon) {
	let selections = [];
	let conf = getConfiguration();
	for (let k in coupon.events) {
		let event = coupon.events[k];
		let market = event.scommessa;
		let eventSelection = {};
		eventSelection.pal = event.pal;
		eventSelection.avv = event.avv;
		eventSelection.banker = false;
		eventSelection.descEvent = event.desc;
		eventSelection.isLive = false;
		eventSelection.alias = event.alias;
		eventSelection.descSport = event.descSport;
		eventSelection.descTournament = event.descTournament;
		eventSelection.timestamp = event.timestamp;
		eventSelection.sportId = event.sportRef;
		eventSelection.bets = [];
		let addedBet = {};
		addedBet.scomSogei = market.id;
		addedBet.handicap = market.handicap;
		addedBet.descBet = market.desc;
		addedBet.draw = event.selectedOdd;
		let odd = null;
		let descDraw = null;
		for (let kq in market.odds) {
			if (market.odds[kq].id == event.selectedOdd) {
				odd = market.odds[kq].rawValue;
				descDraw = market.odds[kq].desc;
			}
		}
		addedBet.descDraw = descDraw;
		addedBet.odd = odd + "";
		addedBet.legabile = false;
		addedBet.amount = conf.cs.imqf; // for singlebet
		addedBet.printableAmount = getPrintableAmount(addedBet.amount, conf.cs.m, conf.cs.nd); // for singlebet
		eventSelection.bets.push(addedBet);
		selections.push(eventSelection);
		
	}
	return selections;
}

export function scrollToTarget(scroller, target) {
    scroller.scrollTo({
        top: 0,
        left: target.getBoundingClientRect().left,
        behavior: 'smooth'
    });
}

export function nHoursFromNow(n) {
    const d = new Date();
    d.setHours(d.getHours() + n);
	const year = d.getFullYear();
	const month = addZero(d.getMonth() + 1);
	let date = addZero(d.getDate());
	const hours = addZero(d.getHours());
	const minutes = addZero(d.getMinutes());
	const seconds = addZero(d.getSeconds());

	date = `${year}${month}${date}`;
	const time = `${hours}:${minutes}:${seconds}`;

	return `${date} ${time}`;
}

export function nDaysFromNow(n) {
    const d = new Date();
    d.setDate(d.getDate() + n);
	const year = d.getFullYear();
	const month = addZero(d.getMonth() + 1);
	let date = addZero(d.getDate());

	date = `${year}${month}${date}`;

	return date;
}

export function filterMatchesByTimestamp(matches, filter) {
    const conf = getConfiguration();
    if (HOURS_FILTERS.includes(filter)) {
        return matches.filter(match => {
            const maxTimestamp = nHoursFromNow(HOURS_FROM_FILTER[filter]);
            let timestamp = match.timestampDB;
            if (conf.dbutc) {
                timestamp = getLocaleTimestamp(match.timestampDB);
            }
            return timestamp <= maxTimestamp;
        });    
    } else if (DAYS_FILTERS.includes(filter)) {
        return matches.filter(match => {
            const maxDate = nDaysFromNow(DAYS_FROM_FILTER[filter]);
            const date = match.timestampDB.split(' ')[0];
            return date <= maxDate;
        });
    } else {
        return matches;
    }
}

export function groupEventsByDate(events) {
    const conf = getConfiguration();
    const dates = [];
    const eventsByDate = {};
    events.forEach(match => {
        let timestamp = conf.dbutc ? getLocaleTimestamp(match.timestampDB): match.timestampDB;
        timestamp = timestamp.split(' ')[0];  // Prendi solo la data
        if (eventsByDate[timestamp] == null) {
            eventsByDate[timestamp] = [];
            dates.push(timestamp);
        }
        eventsByDate[timestamp].push(match);
    });
    dates.sort();

    return [dates, eventsByDate];
}

export function getBetAggr(scomSogei, handicap) {
	let market = window.xs_ag.betById[`${scomSogei}_${handicap}`];
	if (handicap != 0 && !market) {
		market = window.xs_ag.betById[`${scomSogei}_0`];
	}
	return market;
}

export function getAggregationAndBetFromBetId(scomSogei, handicap) {
	let aggList = window.xs_ag.agsByBetId[`${scomSogei}_${handicap}`];
	if (!aggList && handicap != 0) {
		aggList = window.xs_ag.agsByBetId[`${scomSogei}_0`];
	}
	let market = getBetAggr(scomSogei, handicap);
	let aggregation = null;
	if (aggList) {
		let minorIndex = 0;
		let ranking = -1;
		for (let ka in aggList) {
			if (aggList[ka].ranking < ranking || ranking === -1) {
				minorIndex = ka;
				ranking = aggList[ka].ranking;
			}
		}
		aggregation = aggList[minorIndex];
		for (let ks in aggregation.scommesse) {
			const bet = aggregation.scommesse[ks];
			if (bet.id === scomSogei && bet.handicap == handicap) {
				market = bet;
				break;
			}
		}
	}
	
	return {
		market,
		aggregation
	};
}

export function getAggregationAndBetFromBetIdAndSportId(sportId, scomSogei, handicap) {
	let aggList = window.xs_ag.agsByBetIdAndSportId[`${sportId}_${scomSogei}_${handicap}`];
	if (!aggList && handicap != 0) {
		aggList = window.xs_ag.agsByBetIdAndSportId[`${sportId}_${scomSogei}_0`];
	}
	let market = null;
	let aggregation = null;
	if (aggList) {
		let minorIndex = 0;
		let ranking = -1;
		let principaleFound = false;
		for (let ka in aggList) {
			if (!principaleFound && (aggList[ka].isPrincipale || aggList[ka].ranking < ranking || ranking === -1)) {
				minorIndex = ka;
				ranking = aggList[ka].ranking;
				if (aggList[ka].isPrincipale) {
					principaleFound = true;
				}
			}
		}
		aggregation = aggList[minorIndex];
		for (let ks in aggregation.scommesse) {
			const bet = aggregation.scommesse[ks];
			if (bet.id === scomSogei) {
				if (bet.handicap == handicap) { // NB: handicap in the bet object could be string: then "==" instead of "==="
					market = bet; // the specific line has the priority in the case when the aggregate contains the parametric markets and ALSO the specific lines
				}
				else if (bet.handicap == 0 && handicap != 0 && !market) {
					market = bet;
				}
			
			}
		}
	}
	if (!market) {
		market = getBetAggr(scomSogei, handicap);
	}
	
	return {
		market,
		aggregation
	};
}

window.getAggregationAndBetFromBetId = getAggregationAndBetFromBetId;
window.getAggregationAndBetFromBetIdAndSportId = getAggregationAndBetFromBetIdAndSportId;


export function iconSportCssClass(sportId, iconClass) {
	let cssClass = `icoSport${sportId}`;
	if (iconClass?.length > 0) {
		cssClass += ` cms-setted-sport-${iconClass}`;
	}
	return cssClass;
}

export function iconCategoryCssClass(sportId, categoryId, iconClass) {
	let cssClass = `icoCategory${sportId}-${categoryId}`;
    if (iconClass?.length > 0) {
        cssClass += ` cms-setted-category-${iconClass}`;
    }
	return cssClass;
}

export function getBarcode(source, width, displayValue) {

	let barcode = document.createElement('img');
	$(barcode).attr({
		style: "height: 50px; width:100%; display:none;",
		id: "barcode"
	});
	document.body.appendChild(barcode);
	const confObject = {
		format: "CODE128",
		height: 60	
	}
	if (width != undefined) {
		confObject.width = width;
	}
	if (displayValue != undefined) {
		confObject.displayValue = displayValue;
	}
	window.JsBarcode("#barcode", source, confObject);
	return $(barcode)[0].src;	
}

export function getBarcodeIdTicket(id, reprint){
	const conf = getConfiguration();
	if(reprint && conf.rs.pprp){
		//id = REPRINT_ID_ANCHOR + id;
		id = id + REPRINT_ID_ANCHOR;

	}
	return id;
}

export function hasSpecialChar(str){
	/[~`!#$£%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(str);
}

export function scanTicketId(id){
	if(id){
		let isReprint = id.indexOf(REPRINT_ID_ANCHOR) >= 0;
		if(!isReprint && id.length > 2){
			// isolo gli ultimi due. Se il secondo è una R e il primo è un carattere speciale (alcuni scanner non riescono a riconoscere il ! e lo convertono in un altro carattere speciale)
			const lastTwo = id.substr(id.length - 2, id.length);
			isReprint = lastTwo.charAt(1) === 'R' && hasSpecialChar(lastTwo.charAt(0));
		}
		return {
			isReprint,
			id : id.replaceAll(REPRINT_ID_ANCHOR, '').replace(/[\r\n]+/gm, "")
		}	
	}
	return {
		isReprint : false,
		id : ''
	}
}

export function getBarcodeApk(source, widthDisp) {
	let barcode = document.createElement('img');
	$(barcode).attr({
		style: "height: 100px; width:" + widthDisp + "px; display:none;",
		id: "barcode"
	});
	document.body.appendChild(barcode);
	const margin = (widthDisp * 9.5) / 100;
	let widthBar = margin / 10;
	const confObject = {
		format: "CODE128",
		height: 100,
		"width": widthBar,
		"margin-left": margin + "px"
	}
	window.JsBarcode("#barcode", source, confObject);
	return $(barcode)[0].src;	
}


export function normalizeNumber(amount) {
	let currentValue = amount;
	//Numero finisce con la virgola
	if (amount.length > 0) {
		if (isNaN(currentValue.substr(currentValue.length - 1))) {
			currentValue = currentValue.substr(0,currentValue.length - 1);
			amount = currentValue;
		}
		else{
			let n = parseFloat(currentValue.replace(/,/g,"."));
			amount = n;
		}
	}
	else {
		amount = 0;
	}
	return amount;
}

export function truncateDoubleTo(double, nDec){
	let ds = double + "";
	let decimalPart = ds.split(".")[1];
	let fixed = "";
	if(decimalPart){
		for(let i = 0; i < decimalPart.length; i++){
			fixed = fixed + decimalPart.charAt(i);
			if(fixed.length == nDec){
				break;
			}
		}	
	}
	while(fixed.length < nDec){
		fixed += '0';
	}
	return ds.split(".")[0] + "." + fixed;
}

export function getAmountInCent(amountDouble, mult) {
	let centAmount = 0;
	if (amountDouble != null) {
		centAmount = amountDouble * mult;
		let centString = centAmount + "";
		if (centString.indexOf(".") >= 0) {
			// c'e' stato errore nella conversione. Manca un centesimo nel risultato. Es: 64.49 -> 6448.99999 invece
			// di 6449 oppure 64.40 -> 6440.00000000001
			let decimals = centString.split(".")[1];
			centString = centString.split(".")[0]; // isolo la parte prima del punto
			centAmount = parseInt(centString, 10);
			
			if (decimals != null && decimals.startsWith("9")) {
				centAmount ++; // aggiungo 1				
			}
		}
	}
	
	return centAmount;
}

export function getAmountInDouble(amountCent, mult, nDec) {
	return parseFloat(roundNumber(amountCent / mult, nDec));
}

export function isSportToBeHidden(sportId, desc) {
	let toHide = false;
	const entityRules = getConfiguration().eruls;
	if (entityRules != null) {
		const map = entityRules.hsps;
		const hiddenById = map != null && map[sportId] != null;
		toHide = hiddenById || isEntityToBeHiddenByDesc(desc);
	}
	return toHide;
}


export function isCategoryToBeHidden(categoryId, desc) {
	let toHide = false;
	const entityRules = getConfiguration().eruls;
	if (entityRules != null) {
		const map = entityRules.hcts;
		const hiddenById = map != null && map[categoryId] != null;
		toHide = hiddenById || isEntityToBeHiddenByDesc(desc);
	}
	return toHide;
}

export function isTournamentToBeHidden(tournamentId, desc) {
	let toHide = false;
	const entityRules = getConfiguration().eruls;
	if (entityRules != null) {
		const map = entityRules.htns;
		const hiddenById = map != null && map[tournamentId] != null;
		toHide = hiddenById || isEntityToBeHiddenByDesc(desc);
	}
	return toHide;
}

export function isEventToBeHidden(matchId, desc) {
	let toHide = false;
	const entityRules = getConfiguration().eruls;
	if (entityRules != null) {
		const map = entityRules.hevs;
		const hiddenById = map != null && map[matchId] != null;
		toHide = hiddenById || isEntityToBeHiddenByDesc(desc);
	}
	return toHide;
}

export function isEntityToBeHiddenByDesc(desc) {
	let toHide = false;
	if (desc != null) {
		const entityRules = getConfiguration().eruls;
		if (entityRules != null) {
			const map = entityRules.hifcon;
			if (map != null) {
				for (let k in map) {
					const value = map[k];
					toHide = toHide || desc.toUpperCase().indexOf(value.toUpperCase()) >= 0;
				}
			}
		}
	}
	
	return toHide;
}

export function filterByCustomizedState(elems) {
	const systemCode = getConfiguration().sys;
	const filteredElems = [];
	for (let ke in elems) {
		const elem = elems[ke];

		const keyMapSkinCode = systemCode;
		let keyMapGroupCode = null;
    	let keyMapShopCode = null;
		if (window.appConfig.TERMINAL_AGENCY) {
			const operator = window.getLoggedParamsFromLS();
			if (operator) {
				if (operator.groupId) {
					keyMapGroupCode = "GRP-" + operator.groupId;
				}
				const servicesMap = operator.servicesMap? operator.servicesMap: operator.hash_servizi;
				const cnPvend = servicesMap['SPORT'];
				if (cnPvend) {
					const cn = cnPvend.split("/")[0];
					const pvend = cnPvend.split("/")[1];
					keyMapShopCode = cn + "_" + pvend;
				}
			}
    	}
    	else if (window.appConfig.SELF_CASHIER) {
			const cashier = window.getVoucherParamsFromLS();
      		if (cashier) {
				if (cashier.groupId) {
					keyMapGroupCode = "GRP-" + cashier.groupId;
				}
				const servicesMap = cashier.servicesMap? cashier.servicesMap: cashier.hash_servizi;
				const cnPvend = servicesMap['SPORT'];
				if (cnPvend) {
					const cn = cnPvend.split("/")[0];
					const pvend = cnPvend.split("/")[1];
					keyMapShopCode = cn + "_" + pvend;
				}
			}
		}

		let stateCustom = null;
		const stateMap = elem.csm? elem.csm: {};
		//high priority: shop
		if (keyMapShopCode && stateMap[keyMapShopCode] !== null) {
    		stateCustom = stateMap[keyMapShopCode];
    	}
    	
	    // less priority: group of this shop
		if (keyMapGroupCode && stateMap[keyMapGroupCode] !== null && !stateCustom) {
			stateCustom = stateMap[keyMapGroupCode];
		}
		// lowest priority: skin customization
		if (stateMap[keyMapSkinCode] !== null && !stateCustom) {
			stateCustom = stateMap[keyMapSkinCode];
		}
				
		const loadIt = stateCustom !== 'CL';
		if (loadIt) {
			filteredElems.push(elem);
		}
	}
	
	return filteredElems;
}


export function getDataAndSelectionsFromBetslipTicketDTO(ticket) {
	const conf = getConfiguration();
	const nDec = conf.cs.nd;
	const mult = conf.cs.m;
	const purchaseType = ticket.purchaseType;
	// TO BE RETURNED
	const selections = [];
	let amount = ticket.amount;
	let systemSelections = null;
	
	if (purchaseType === 'systembets' || amount == 0) {
		amount = purchaseType === 'systembets'? conf.cs.imqfs: conf.cs.imqf;
	}
	if (ticket.taxOnStake) {
		amount += ticket.taxOnStake;
	}
	for (let k in ticket.events) {
		const event = ticket.events[k];
		const eventSelection = {};
		eventSelection.pal = event.pal;
		eventSelection.avv = event.avv;
		eventSelection.banker = false;
		eventSelection.descEvent = event.descAvv;
		eventSelection.isLive = event.live;
		eventSelection.alias = event.alias;
		eventSelection.descSport = event.descSport;
		eventSelection.descTournament = event.descTournament;
		eventSelection.timestamp = event.timestamp;
		eventSelection.sportId = event.sportRef || event.sportId;
		eventSelection.tournamentId = event.tournamentId;
		eventSelection.categoryId = event.categoryId;
		eventSelection.banker = event.fixed;
		eventSelection.closed = event.closed;
		try {
			const seoSettingsAdds = {[systemCode]:{[xs_languageCode]:{nf:true}}}; //nofollow,noindex
			eventSelection.matchData = {
				urlPath: getUrlPath({uniqueId: `${event.sportId}_${event.categoryId}_${event.tournamentId}`, urlPath: `${event.descSport}/${event.descTournament}`}, {p:event.pal,a:event.avv}, event.descAvv),
				urlPathSeoSettings: getUrlPathSeoSettings({seoSettingsAdds:JSON.stringify(seoSettingsAdds)})
			};
		}catch(err) {
			console.error(err);
		}
		
		const bets = [];
		for (let km in event.bets) {
			const bet = event.bets[km];
			let betDataAggr = getAggregationAndBetFromBetId(bet.scomSogei, bet.handicap);
			if (betDataAggr.market == null && bet.handicap != 0) {
				betDataAggr = getAggregationAndBetFromBetId(bet.scomSogei, 0);
			}
			let betFromAgg = betDataAggr.market;
    		const addedBet = {};
    		addedBet.scomSogei = bet.scomSogei;
    		addedBet.handicap = bet.handicap;
    		addedBet.descBet = bet.rawDescScom;
    		addedBet.descDraw = bet.rawDescDraw;
    		addedBet.draw = bet.codDraw;
    		addedBet.odd = bet.odd + "";
    		
    		addedBet.legabile = false;
    		
    		if (betFromAgg != null) {
    			addedBet.legabile = betFromAgg.legabile;
    			let descScom = betFromAgg.desc;
    			let descDraw = addedBet.descDraw;
    			const aggregation = betDataAggr.aggregation;
    			if (betFromAgg.hideHandicap) {
                	/*
                	 * 1) aggregate description overrides the market description
                	 * 2) original market description overrides the draw description
                	 * */
                	if (aggregation) {
                		descScom = aggregation.descrizione;
                		descDraw = betFromAgg.desc;		                		
                	}
    			}
    			else{
    				// finding the compacted bet name
                	if (aggregation && aggregation.compattate) {
                		for (let name in aggregation.compattate) {
                			const listMarket = aggregation.compattate[name];
                			for (let mark in listMarket) {
                				const values = listMarket[mark].split("_");
								const scomSogei = parseInt(values[0], 10);
								const handicap = parseInt(values[1], 10);
                				if (scomSogei === bet.scomSogei && handicap == bet.handicap) {
                					descScom = name;
                					break;
                				}
                			}
                		}
                		if (aggregation.localeCmpDesc && aggregation.localeCmpDesc[descScom] && aggregation.localeCmpDesc[descScom][xs_languageCode]) {
                			descScom = aggregation.localeCmpDesc[descScom][xs_languageCode];
                		}
                	}
        			if (bet.handicap != 0 || betFromAgg.calculateHandicapDescription) {
        				descScom = parseHandicap(descScom, bet.handicap, bet.handicapType, bet.draws, bet.dia);
        			}
        			for (let ko in betFromAgg.odds) {
        				if (betFromAgg.odds[ko].id == addedBet.draw) {
							const drawFromAgg = betFromAgg.odds[ko];
        					descDraw = drawFromAgg.desc;
							if (drawFromAgg.tooltip && drawFromAgg.tooltip !== '' && conf.tod) {
								const teams = eventSelection.descEvent.split(' - ');
								if (teams.length > 1) {
									descDraw = drawFromAgg.tooltip;
									descDraw = descDraw.replaceAll('{{TEAM1}}', teams[0]);
									descDraw = descDraw.replaceAll('{{TEAM2}}', teams[1]);
								}
							}
        				}
        			}
    			}
    			
    			addedBet.descBet = descScom;
    			addedBet.descDraw = descDraw;

    		}
    		addedBet.amount = amount; // for singlebet
    		addedBet.printableAmount = getPrintableAmount(addedBet.amount, mult, nDec); // for singlebet
    		bets.push(addedBet);
			
		}
		eventSelection.bets = bets;
		selections.push(eventSelection);
	}
	if (ticket.purchaseType === 'systembets' && selections.length > 0) {
		systemSelections = {};
		for (let kt in ticket.tuples) {
			const tupla = ticket.tuples[kt];
			const kc = tupla.id;
			systemSelections[kc] = {};
			systemSelections[kc].selected = true;
			systemSelections[kc].amount = tupla.amount;
			systemSelections[kc].printableAmount = getPrintableAmount(tupla.amount, mult, nDec);
			systemSelections[kc].vMin = 0;
			systemSelections[kc].vMax = 0;
		}
	}
	
	
	return {
		selections,
		systemSelections,
		amount
	}
}

export function getHiddenTicket(idTicket) {
	let ticket = idTicket;
	if (ticket != null && ticket.length > 4) {
		let ln = ticket.length;
		ticket = ticket.substr(0, ln - 4);
		ticket += '****';
	}
	return ticket;
}

export function getPlayabilityClasses(ming, maxg) {
    let classes = null;
    if (ming != null) {
        if (maxg === 1 && ming === 1) {
            classes = 'blocco-giocab blocco-giocab--1';
        } else if (ming === 2) {
            classes = 'blocco-giocab blocco-giocab--2';
        } else if (ming === 3) {
            classes = 'blocco-giocab blocco-giocab--3';
        } else if (ming === 4) {
            classes = 'blocco-giocab blocco-giocab--4';
        } else if (ming === 5) {
            classes = 'blocco-giocab blocco-giocab--5';
        }
    }

    return classes;
}

export function addPrintOverlay(invokerFunction) {
    document.body.classList.add('bodyOverlay');
	addInhibitKeysListener();
	invokerFunction && invokerFunction();
}

export function removePrintOverlay(removeInvokerFunction) {
    if (window.xs_printOverlayTimeout) {
        clearTimeout(window.xs_printOverlayTimeout);
    }
    document.body.classList.remove('bodyOverlay');
	setTimeout(() => {
		removeInhibitKeysListener();
	}, 3000);
	
	removeInvokerFunction && removeInvokerFunction();
}

export function addInhibitKeysListener() {
	if(window.xs_inhibitKeysListener) {
		window.removeEventListener('keydown', window.xs_inhibitKeysListener);
	}
	window.xs_inhibitKeysListener = function (e){
		try {
			const evt = window.event? window.event : e;
			switch(evt.keyCode) {
				case 116: {
					e.preventDefault();
					e.stopPropagation();
					console.debug("F5 key pressed: inhibited!");
					break;
				}
				case 27: {
					e.preventDefault();
					e.stopPropagation();
					console.debug("ESC key pressed: inhibited!");
					break;
				}
				default:
					break;
			}
		}catch(err) {
			console.error(err);
		}
		
	}
	if(window.xs_inhibitKeysListener) {
		window.addEventListener('keydown', window.xs_inhibitKeysListener);
	}
}

export function removeInhibitKeysListener() {
	try {
		if(window.xs_inhibitKeysListener) {
			window.removeEventListener('keydown', window.xs_inhibitKeysListener);
		}
	}catch(err) {
		console.error(err);
	}
}

export function getCompactedBetUniqueId(ags) {
    let result = '';
    for (let i = 0; i < ags.length; i++) {
        result += result === '' ? ags[i]: `_${ags[i]}`;
    }
    return result;
}

export function selectInputText(e) {
    $(e.target).select();
}

export function getTournamentUniqueId(fullId) {
    const parts = fullId.split('_');
    return `${parts[0]}_${parts[1]}_${parts[2]}`;
}

export function splitTournamentUniqueId(fullId) {
    const parts = fullId.split('_');
	const result = parts.map(id => parseInt(id, 10));
	
	return result;
}

export function getMatchIdOrStageId(match) {
    if (SPORTS_WITH_STAGE_ID.includes(match.sportRef || match.sportId)) {
        return match.round;
    } else {
        return match.id;
    }
}

export function getFilterDesc(filter) {
    switch (filter) {
        case '1H':
            return getLabel('prematch_page.temporal_filters.1h');
        case '3H':
            return getLabel('prematch_page.temporal_filters.3h');
        case 'TODAY':
            return getLabel('prematch_page.temporal_filters.today');
        case '2D':
            return getLabel('prematch_page.temporal_filters.2d');
        case '3D':
            return getLabel('prematch_page.temporal_filters.3d');
        case 'ALL':
            return getLabel('prematch_page.temporal_filters.all');
        default:
            return '';
    }
}

export function getFilterDescWithLive(filter) {
    switch (filter) {
		case 'LIVE':
            return "Live";
        case '1H':
            return getLabel('prematch_page.temporal_filters.1h');
        case '3H':
            return getLabel('prematch_page.temporal_filters.3h');
        case 'TODAY':
            return getLabel('prematch_page.temporal_filters.today');
        case '2D':
            return getLabel('prematch_page.temporal_filters.2d');
        case '3D':
            return getLabel('prematch_page.temporal_filters.3d');
        case 'ALL':
            return getLabel('prematch_page.temporal_filters.all');
        default:
            return '';
    }
}

window.localStorageSpace = function() {
    var allStrings = '';
    for (var key in window.localStorage) {
        if (window.localStorage.hasOwnProperty(key)) {
            allStrings += window.localStorage[key];
        }
    }
    return allStrings ? 3 + ((allStrings.length*16)/(8*1024)) + ' KB': 'Empty (0 KB)';
};

export function getBaseURL() {
	if (!window.XSPORT_PUBLIC_URL.startsWith('http')) {
		if (window.cg_SYSTEM_CODE != null) {
			return  `${new URL(window.location.href).origin}`;
		} else {
			return  `${new URL(window.location.href).origin}${window.XSPORT_PUBLIC_URL}`;
		}
	}
	return window.XSPORT_PUBLIC_URL;
}

export function getPrematchPage(isMobile) {
	const defaultPrematchPage = '/prematch';
	if (isMobile) {
		return (window.appConfig && window.appConfig.ROUTES && window.appConfig.ROUTES.prematch && window.appConfig.ROUTES.prematch.prematch) || defaultPrematchPage;
	}else{
		return (window.appConfig && window.appConfig.ROUTES && window.appConfig.ROUTES.checkbet && window.appConfig.ROUTES.prematch['top-match']) || defaultPrematchPage;
	}
}

export function getCheckbetPage(isMobile) {
	const defaultCheckbetPage = '/checkbet';
	if (isMobile) {
		return (window.appConfig && window.appConfig.ROUTES && window.appConfig.ROUTES.prematch && window.appConfig.ROUTES.prematch.checkbet) || defaultCheckbetPage;
	}else{
		return (window.appConfig && window.appConfig.ROUTES && window.appConfig.ROUTES.checkbet && window.appConfig.ROUTES.checkbet['checkbet']) || defaultCheckbetPage;
	}
}

export function getCheckbetUrl(ticketId) {
    const conf = getConfiguration();

    let ticketUrl = '';
    if (conf.xspu && conf.xspu.chb) {
        ticketUrl = conf.xspu.chb.replaceAll('{{TICKET}}', ticketId);
        ticketUrl = ticketUrl.replaceAll('{{SYSTEM_CODE}}', systemCode);
        ticketUrl = ticketUrl.replaceAll('{{LANG}}', xs_languageCode);
        ticketUrl = restoreURL(ticketUrl);
    } else {
        const baseURL = getBaseURL();
        const checkbetPage = getCheckbetPage(xs_isMobile);
        // always in mobile version, 'cause it is full resposive
        ticketUrl = `${baseURL.replace('xsport_desktop', 'xsport_mobile')}${checkbetPage}?ticket=${ticketId}&system_code=${systemCode}&language=${xs_languageCode}`;
    }

    return ticketUrl;
}

export function getCheckSystemBetsPage(isMobile) {
	const defaultPage = '/checksystembets';
	if (isMobile) {
		return (window.appConfig && window.appConfig.ROUTES && window.appConfig.ROUTES.prematch && window.appConfig.ROUTES.prematch.checksystembets) || defaultPage;
	}else{
		return (window.appConfig && window.appConfig.ROUTES && window.appConfig.ROUTES.checksystembets && window.appConfig.ROUTES.checksystembets['checksystembets']) || defaultPage;
	}
}

export function getMybetsPage(isMobile) {
	const defaultMybetsPage = '/mybets';
	if (isMobile) {
		return (window.appConfig && window.appConfig.ROUTES && window.appConfig.ROUTES.mybets && window.appConfig.ROUTES.prematch.mybets) || defaultMybetsPage;
	}else{
		return (window.appConfig && window.appConfig.ROUTES && window.appConfig.ROUTES.mybets && window.appConfig.ROUTES.mybets['mybets']) || defaultMybetsPage;
	}
}

export function getBetslipPage(isMobile) {
	const defaultBetslipPage = '/betslip';
	const customBetslipPage = getQueryStringVariable('betslipPage');
	if (isMobile) {
		return customBetslipPage || (window.appConfig && window.appConfig.ROUTES && window.appConfig.ROUTES.prematch && window.appConfig.ROUTES.prematch.betslip) || defaultBetslipPage;
	}else{
		return customBetslipPage || (window.appConfig && window.appConfig.ROUTES && window.appConfig.ROUTES.betslip && window.appConfig.ROUTES.betslip['betslip']) || defaultBetslipPage;
	}
}

export function multiplyAndRound(num, mult) {
	let result = (num * mult).toFixed(2);
	return parseFloat(result);
}

export function getReservationCodeType() {
    let type = 'barcode';
    let item = localStorage.getItem('xs_reservation_print_type');
	if (item != null) {
        type = item;
    }
    return type;
}

export function setReservationCodeType(type) {
    localStorage.setItem('xs_reservation_print_type', type);
}

export function getDayDesc(day) {
    switch (day) {
        case 1:
        return getLabel('general.week_days_short.mon');
        case 2:
        return getLabel('general.week_days_short.tue');
        case 3:
        return getLabel('general.week_days_short.wed');
        case 4:
        return getLabel('general.week_days_short.thu');
        case 5:
        return getLabel('general.week_days_short.fri');
        case 6:
        return getLabel('general.week_days_short.sat');
        case 7:
        return getLabel('general.week_days_short.sun');
        default:
        return '';
    }
}

export function getIdContoNumConto() {
	const idConto = window.appConfig && window.appConfig['ID_CONTO'];
	const numConto = window.appConfig && window.appConfig['NUM_CONTO'];
    return idConto && numConto && [idConto,numConto].join(';');
}

export function getAccountIds() {
    return localStorage.getItem('lastLoggedUserAccountIds') || getIdContoNumConto();
}

export function stringCapitalize(string) {
	const firstLetter = string && string.charAt(0);
	const trailingLetters = string && string.slice(1);
	let toReturn = ((firstLetter && firstLetter.toUpperCase()) || '')+((trailingLetters && trailingLetters.toLowerCase()) || '')
	return toReturn || string;
}

export function getHandicapSelections(matches) {
    const selectionsById = new Map();
    matches.forEach(m => {
        m.betsById.forEach((bets, id) => {
            bets.forEach(b => {
                b.selectionId = `${b.id}_${b.handicap}`;
                if (!selectionsById.has(id)) {
                    selectionsById.set(id, {set: new Set(), selections: []});
                }
                const v = selectionsById.get(id);
                const [set, selections] = [v.set, v.selections];
                if (!set.has(b.selectionId)) {
                    set.add(b.selectionId);
                    selections.push(b);
                }
            });
        });
    });

    return selectionsById;
}

export function getStatsUrl(matchId) {
    const conf = getConfiguration(), lang = loadLanguage().toLowerCase();
    return conf.ps.sts.replace('{{lang}}', lang).replace('{{matchid}}', matchId);
}

export function getSeasonStatsUrl(seasonId, sportId) {
    const conf = getConfiguration(), lang = loadLanguage().toLowerCase();
    return conf.ps.clt.replace('{{lang}}', lang).replace('{{sportId}}', sportId).replace('{{seasonId}}', seasonId);
}

export let getAnimationDuration = function() {
    const DEFAULT_DURATION = 4000;
    let duration = DEFAULT_DURATION;
    const livePollingInterval = getConfiguration()?.lpo ?? 0;
    if ((livePollingInterval - 500) > DEFAULT_DURATION) {
        duration = livePollingInterval - 500;
    }
    getAnimationDuration = () => duration;
}

export function getEncodedURI(uri) {
	const decoded = decodeURI(uri);
	return decoded == uri? encodeURI(uri): uri;

}

export function getLiveSportPathname() {
	const p = xs_isMobile?'live':'live-suite';
	const base = appConfig?.ROUTES?.live?.[p];
	return xs_isMobile?concatUrlPathnames(base,'/ls'):base;
}

export function getLiveMatchPathname() {
	const p = xs_isMobile?'live':'live-match';
	const base = appConfig?.ROUTES?.live?.[p];
	return xs_isMobile?concatUrlPathnames(base,'/lm'):base;
}

export function getLiveSportWindowLocationHash(sportId) {
	return "#"+sportId;
}

export function getLiveMatchWindowLocationHash(sportId, countryId, tournamentId, matchId) {
	return "#"+[sportId,countryId,tournamentId,matchId].join('_')
}

export function parseWindowLocationHash(isLive) {
	const hash = window.location.hash;
	let toReturn = {}
	if (isLive) {
		const matchUniqueId = hash && hash.replace("#","");
		try {
			if (matchUniqueId) {
				const parts = matchUniqueId.split('_');
				if (parts) {
					if (parts.length === 1) {
						toReturn = {
								isSport:true,
								sportId: parseInt(parts[0], 10)
						}
					}
					if (parts.length === 4) {
						toReturn = {
							isMatch:true,
							matchUniqueId: matchUniqueId,
							sportId: parseInt(parts[0], 10),
							countryId: parseInt(parts[1], 10),
							tournamentId: parseInt(parts[2], 10),
							matchId: parseInt(parts[3], 10)
						}
					}
				}
			}
		}catch(err) {
			console.log(err);
			return null;
		}
    	return toReturn;
	}else{
		return null;
	}
}

export function getSimpleKeyboardLayout() {
	// TODO: here we can return the layouts for the specific languages
	return {
		'default':[
			'1 2 3 4 5 6 7 8 9 {bksp}',
			'q w e r t y u i o p Clear.',
			'{lock} a s d f g h j k l',
			'{shift} z x c v b n m {enter}',
			'{space}'
		],
		'shift':[
			'1 2 3 4 5 6 7 8 9 {bksp}',
			'Q W E R T Y U I O P Clear.',
			'{lock} A S D F G H J K L',
			'{shift} Z X C V B N M {enter}',
			'{space}'
		]

	}
}

export function showMatchDesc(odd) {
    const conf = getConfiguration();
    if (conf.tod) {
        const sportRef = odd.matchData.sportRef, aggId = odd.betData.aggId;
        const agg = odd.betData.isLive ? getLiveAggs(sportRef, aggId): getPrematchAggs(sportRef, aggId);
        return agg && agg.scommesse?.[0]?.id === odd.betData.id;
    }
    return false;
}

export function getRFC3339Date() {
    const date = new Date().toISOString().slice(0, 10);
    return date;
}

let browserPublicIp = '';
export function setPublicIp(ip) {
	browserPublicIp = ip;
}

export function getPublicIp() {
	return browserPublicIp? browserPublicIp: '';
}

export function addSlash(url) {
    if (!url.startsWith('/')) {
        return `/${url}`;
    }
    return url;
}

export const checkPathnameIsMatching = function(urlA, urlB) {
	if (!urlA.startsWith("/")) {
		urlA = "/" + urlA;
	}
	if (!urlB.startsWith("/")) {
		urlB = "/" + urlB;
	}
	let matched = urlA === urlB;
	if (!matched) {
		if (urlA.indexOf("*") >= 0) {
			const urlTrunc = urlA.split("*")[0];
			matched = urlB.indexOf(urlTrunc) >= 0;
		}
		else if (urlB.indexOf("*") >= 0) {
			const urlTrunc = urlB.split("*")[0];
			matched = urlA.indexOf(urlTrunc) >= 0;
		}
		
	}
	return matched;
}

export const checkPathnameStartsWith = function(urlA, urlB) {
	if (!urlA.startsWith("/")) {
		urlA = "/" + urlA;
	}
	if (!urlB.startsWith("/")) {
		urlB = "/" + urlB;
	}
	return urlA.startsWith(urlB);
}


export function filterSportsFromSearchResults(data, search) {
    let sports = [];

    if (data == null) {
        return sports;
    }

    const results = filterSearchResults(data, search, 'MATCH', function(match) {
        return match.desc;
    });

    const sportById = {};
    results.forEach(function(match) {
        if (sportById[match.sportRef] == null) {
            const sport = {
                id: match.sportRef,
                desc: match.sportDesc,
                tournaments: [],
                tournamentById: {},
            };
            sports.push(sport);
            sportById[match.sportRef] = sport;
        }
        const sport = sportById[match.sportRef];
        if (sport.tournamentById[match.tournamentRef] == null) {
            const tournament = {
                id: match.tournamentRef,
                desc: match.tournamentDesc,
                events: [],
            };
            sport.tournaments.push(tournament);
            sport.tournamentById[match.tournamentRef] = tournament;
        }
        const tournament = sport.tournamentById[match.tournamentRef];
        tournament.events.push(match);
    });
    return sports;
}

export function getPalAvvFromDesc(desc) {
    let avvRef = null;
    try {
        const index = desc.indexOf(') #');
        if (index > 0) {
            const newDesc = desc.slice(0, index + 1);
            const parts = desc.slice(index + 3).split('_');
            const [pal, avv, sportId] = [parseInt(parts[0], 10), parseInt(parts[1], 10), parseInt(parts[2], 10)];
            desc = newDesc;
            avvRef = {pal, avv, sportId};
        }
    } catch (e) {
        console.error(e);
        return [desc, avvRef];
    }
    return [desc, avvRef];
}

export function setCustomizedOdds(bets) {
    for (let kb in bets) {
    	const bet = bets[kb];
    	let customOddsMap = {};
    	if (bet.qps != null && bet.qps.vl != null) {
    		customOddsMap = bet.qps.vl;
    	}
    	for (let kq in bet.eqs) {
    		const draw = bet.eqs[kq];
    		const keyMapSkinCode = `${systemCode}:${bet.cs}:${bet.h}:${draw.ce}`;
    		
    		let keyMapGroupCode = null;
    		let keyMapShopCode = null;
    		const operator = window.getLoggedParamsFromLS();
    		if (operator && (window.appConfig.TERMINAL_AGENCY || window.appConfig.SHOP_BOOKER)) {
				if (operator.groupId) {
					const groupKey = `GRP-${operator.groupId}`;
					keyMapGroupCode = `${groupKey}:${bet.cs}:${bet.h}:${draw.ce}`
				}
				const servicesMap = operator.servicesMap ? operator.servicesMap: operator.hash_servizi;
				const cnPvend = servicesMap['SPORT'];
				if (cnPvend) {
					const cn = cnPvend.split("/")[0];
					const pvend = cnPvend.split("/")[1];
					const cnPvendKey = `${cn}_${pvend}`;
					keyMapShopCode = `${cnPvendKey}:${bet.cs}:${bet.h}:${draw.ce}`;
				}

    		} else if (window.appConfig.SELF_CASHIER) {
    			const cashier = window.getVoucherParamsFromLS();
      			if (cashier) {
    				if (cashier.groupId) {
    					const groupKey = `GRP-${cashier.groupId}`;
    					keyMapGroupCode = `${groupKey}:${bet.cs}:${bet.h}:${draw.ce}`
    				}
    				const servicesMap = cashier.servicesMap ? cashier.servicesMap: cashier.hash_servizi;
    				const cnPvend = servicesMap['SPORT'];
    				if (cnPvend) {
    					const cn = cnPvend.split("/")[0];
    					const pvend = cnPvend.split("/")[1];
    					const cnPvendKey = `${cn}_${pvend}`;
    					keyMapShopCode = `${cnPvendKey}:${bet.cs}:${bet.h}:${draw.ce}`;
    				}
    			}
    		}
    		
    		let customizedOdd = null;
    		//high priority: shop
    		if (keyMapShopCode && customOddsMap[keyMapShopCode] !== null) {
    			customizedOdd = customOddsMap[keyMapShopCode];
    		}
    		
    		// less priority: group of this shop
    		if (keyMapGroupCode && customOddsMap[keyMapGroupCode] !== null && !customizedOdd) {
    			customizedOdd = customOddsMap[keyMapGroupCode];
    		}
    		
    		// less priority: skin customization
    		if (customOddsMap[keyMapSkinCode] !== null && !customizedOdd) {
    			customizedOdd = customOddsMap[keyMapSkinCode];
    		}

			// lowest priority: get the customization from another group or shop or skin code
    		const conf = getConfiguration();
			if(!customizedOdd && conf.cosd && conf.cosd.length > 0){
				const splittedData = conf.cosd.split(";");
				if(splittedData[0] === 'GRP'){
					const substituteGroupId = splittedData[1];
					const keyGroup  = `${substituteGroupId}:${bet.cs}:${bet.h}:${draw.ce}`;
					customizedOdd = customOddsMap[keyGroup];
				}
				else if(splittedData[0] === 'CNPVEND'){
					const substituteCnPvend = splittedData[1];
					const keyShop  = `${substituteCnPvend}:${bet.cs}:${bet.h}:${draw.ce}`;
					customizedOdd = customOddsMap[keyShop];
				}
				else if(splittedData[0] === 'SKIN'){
					const substituteSystemCode = splittedData[1];
					const keySkin  = `${substituteSystemCode}:${bet.cs}:${bet.h}:${draw.ce}`;
					customizedOdd = customOddsMap[keySkin];
				}
			}
    		if (customizedOdd != null) {
    			draw.q = customizedOdd;
    		}
    	}
    }
}


export function addMatchBets(bets, match) {
    const betById = new Map();
    match.bets.forEach(b => betById.set(b.id, b));
    for (let i = 0; i < bets.length; i++) {
        const id = bets[i].cs;
        if (betById.has(id)) {
            bets[i] = betById.get(id);
        }
    }
}

export function getHighlightOddChange(oldValue, newValue) {
    if (newValue == null) {
        return '';
    } else if (oldValue != null && oldValue !== newValue) {
        if (newValue > oldValue) {
            return 'quota-aumentata';             
        } else {
            return 'quota-diminuita';
        }
    }
}

export function getSplitDesc(desc) {
    if (typeof desc !== 'string') {
        return ['', null];
    }
    const parts = desc.split(' - ');
    return [parts[0], parts[1] || null];
}

export function classIf (condition, classes) {
    return condition ? ` ${classes}`: '';
}


export function isGoldenRaceVirtual() {
	const conf = getConfiguration();
	return conf.rs.psvt !== 'internal' && conf.rs.grd;
}

export function isExternalVirtual() {
	return isGoldenRaceVirtual();
}
export function getVirtualLandingPage(rootPath) {
	let psvUrl = null;
	if (rootPath) {
		psvUrl = `${rootPath}/virtual`;
		if (isExternalVirtual()) {
			psvUrl = `${rootPath}/external-virtual`;
		}
	}
	else{
		psvUrl = 'virtual';
		if (isExternalVirtual()) {
			psvUrl = 'external-virtual';
		}
	}
	return psvUrl;
}

export function getVirtualButtonLabel() {
	if (isGoldenRaceVirtual()) {
		return getLabel('header.psv_golden_race');
	}
	return getLabel('header.psv');
}

export function calculateUserSessionId(ut,bl,al,u) {try{const fs =[ut,bl,al].join("/");return btoa(fs);}catch(e) {return '';}}

export function parseIntFromString(number, defaultValue = null) {
    let result = defaultValue;
    if (number?.length > 0 && !isNaN(number)) {
        result = parseInt(number, 10);
    }
    return result;
}


window.getElementByPD = function () {
	let j='\n\n';j += '	    ____\n';j += '	   |    |\n';j += ' ______|    |______\n';j += '|	   			   |\n';j += '|______      ______|\n';j += '	   |    |\n';j += '       |    |\n';j += '       |    |\n';j += '       |    |\n';j += '       |    |\n';j += '       |____|\n';
	console.log(j);
}

export function lowerCaseStringCompare(a, b) {
	return a?.toLowerCase() === b?.toLowerCase();
}

export function isAsianHandicap(betId) {
    const conf = getConfiguration();
    return  conf.nas && ASIAN_HANDICAP.includes(betId);
}

export function handleAsianHandicapITDesc(bet) {
    if (ASIAN_HANDICAP_IT.includes(bet.id)) {
        bet.odds.forEach((odd, i) => {
            if (i === 1) {
                odd.betData = {...odd.betData};
                const desc = odd.betData.desc;
                const regex = /(?<betDesc>.+) \((?<spread>.+)\)/;
                if (regex.test(desc)) {
                    const result = regex.exec(desc);
                    if (result != null) {
                        const groups = result.groups;
                        let spread = groups.spread;
                        if (spread[0] === '+') {
                            spread = `-${spread.slice(1)}`;
                        } else if (spread[0] === '-') {
                            spread = `+${spread.slice(1)}`;
                        }
                        odd.betData.desc = `${groups.betDesc} (${spread})`;
                    }
                }
            }
        });
    }
}

export function getUkCombinationName(combId, isAccumulator) {
	let ukName = '';
	if (isAccumulator) {
			switch (combId) {
				case 1: { ukName = getLabel('uk_system_tuples.single_accumulator'); break; }
				case 2: { ukName = getLabel('uk_system_tuples.double_accumulator'); break; }
				case 3: { ukName = getLabel('uk_system_tuples.treble_accumulator'); break; }
				default: { ukName = getLabel('uk_system_tuples.generic_accumulator'); break; }
		}
	} else {
		switch (combId) {
			case 1: { ukName = getLabel('uk_system_tuples.singles'); break; }
			case 2: { ukName = getLabel('uk_system_tuples.doubles'); break; }
			case 3: { ukName = getLabel('uk_system_tuples.trebles'); break; }
			case 31: { ukName = getLabel('uk_system_tuples.trixie'); break; }
			case 32: { ukName = getLabel('uk_system_tuples.patent'); break; }
			case 33: { ukName = getLabel('uk_system_tuples.yankee11'); break; }
			case 34: { ukName = getLabel('uk_system_tuples.lucky15'); break; }
			case 35: { ukName = getLabel('uk_system_tuples.canadian'); break; }
			case 36: { ukName = getLabel('uk_system_tuples.lucky31'); break; }
			case 37: { ukName = getLabel('uk_system_tuples.heinz'); break; }
			case 38: { ukName = getLabel('uk_system_tuples.lucky63'); break; }
			case 39: { ukName = getLabel('uk_system_tuples.triple_yankee'); break; }
			case 40: { ukName = getLabel('uk_system_tuples.super_heinz'); break; }
			case 41: { ukName = getLabel('uk_system_tuples.goliath'); break; }
			default: { ukName = getLabel('uk_system_tuples.generic_fold').replaceAll('{{COMB-ID}}', combId); break; } 
		}
	}
	return ukName;
}

// num of selections -> rules
export const additionalUkTuplesRules = {
	
	'31' :{
		pseudo: 'trixie',
		index: 31,
		indexesToTakeCombs: [2, 3],
		totalCombsExpected: 4
	},
	'32':{
		pseudo: 'patent',
		index: 32,
		indexesToTakeCombs: [1,2,3],
		totalCombsExpected: 7
	},
	'33':{
		pseudo: 'yankee11',
		index: 33,
		indexesToTakeCombs: [2, 3, 4],
		totalCombsExpected: 11
	},
	'34':{
		pseudo: 'lucky15',
		index: 34,
		indexesToTakeCombs: [1,2,3,4],
		totalCombsExpected: 15
	},
	'35': {
			pseudo: 'canadian',
			index: 35,
			indexesToTakeCombs: [2, 3, 4, 5],
			totalCombsExpected: 26
	},
	'36': {
			pseudo: 'lucky31',
			index: 36,
			indexesToTakeCombs: [1,2,3,4,5],
			totalCombsExpected: 31
	},
	'37': {
			pseudo: 'heinz',
			index: 37,
			indexesToTakeCombs: [2, 3, 4, 5, 6],
			totalCombsExpected: 57
	},
	'38': {
			pseudo: 'lucky63',
			index: 38,
			indexesToTakeCombs: [1,2,3,4,5,6],
			totalCombsExpected: 63
	},
	'39': {
			pseudo: 'triple_yankee', // TO DEVELOP
			index: 39,
			indexesToTakeCombs: [],
			totalCombsExpected: 33
	},
	'40': {
			pseudo: 'super_heinz', 
			index: 40,
			indexesToTakeCombs: [2, 3, 4, 5, 6, 7],
			totalCombsExpected: 120
	},
	'41': {
			pseudo: 'goliath', 
			index: 41,
			indexesToTakeCombs: [2, 3, 4, 5, 6, 7, 8],
			totalCombsExpected: 247
	},
	getAvaialableTuplesByOrdinaryCombinations: function(combinations, totalDraws) {
		let accumulatorCombination = combinations[totalDraws];
		let list = null;
		if (accumulatorCombination == 1) {
			switch(totalDraws) {
				case 3: { list = [additionalUkTuplesRules['31'], additionalUkTuplesRules['32']]; break;}
				case 4: { list = [additionalUkTuplesRules['33'], additionalUkTuplesRules['34']]; break;}
				case 5: { list = [additionalUkTuplesRules['35'], additionalUkTuplesRules['36']]; break;}
				case 6: { list = [additionalUkTuplesRules['37'], additionalUkTuplesRules['38'] /**, additionalUkTuplesRules['39'] */]; break;}
				case 7: { list = [additionalUkTuplesRules['40']]; break;}
				case 8: { list = [additionalUkTuplesRules['41']]; break;}
				default: { list = null; }
			}
		}
		if (list) {
			// check if the "sub" combinations are gt 0
			const definitiveList = [];
			for (let ka in list) {
				let totalCombs = 0;
				const additionalTuple = list[ka];
				for (let ki in additionalTuple.indexesToTakeCombs) {
					const index = additionalTuple.indexesToTakeCombs[ki];
					if (index === 'all_valued') {
						for (let kc in combinations) {
							totalCombs += combinations[kc];
						}
					}
					else {
						totalCombs += combinations[index];
					}
				}
				if (totalCombs == additionalTuple.totalCombsExpected) {
					definitiveList.push(additionalTuple);
				}
			}
			return definitiveList;

		}
		return null;
	},

	getTotalTuplesToAddInList: function() {
		const keys = Object.keys(additionalUkTuplesRules);
		let number = 0;
		for (let k in keys) {
			if (!isNaN(keys[k])) {
				number ++;
			}
		}
		return number;
	},
	
	getListOfAdditionalTuplesByOriginalTupleIndex: function(originalIndex) {
		const list = [];
		const keys = Object.keys(additionalUkTuplesRules);
		const cntMap = {};
		for (let k in keys) {
			const tupleKey = keys[k];
			if (!isNaN(tupleKey)) {
				const additionalTuple = additionalUkTuplesRules[tupleKey];
				for (let i in additionalTuple.indexesToTakeCombs) {
					const index = additionalTuple.indexesToTakeCombs[i];
					if ((index == originalIndex || index === 'all_valued')  && !cntMap[additionalTuple.index]) {
						cntMap[additionalTuple.index] = true;
						list.push(additionalTuple.index);
					}
				}
			}
		}
		return list;	
	},
	
	getAdditionalTuplesByIndexesList(list) {
		const keys = Object.keys(additionalUkTuplesRules);
		const returnMap = {};
		for (let k in keys) {
			const tupleKey = keys[k];
			if (!isNaN(tupleKey)) {
				const additionalTuple = additionalUkTuplesRules[tupleKey];
				const indexesToTakeCombsMap = {};
				let finalKey = '';
				for (let kia in additionalTuple.indexesToTakeCombs) {
					indexesToTakeCombsMap[additionalTuple.indexesToTakeCombs[kia]] = true;
				}
				if (Object.keys(indexesToTakeCombsMap).length > 0) {
					for (let ki = 0; ki < list.length; ki ++) {
						const originalIndex = list[ki];
						delete indexesToTakeCombsMap[originalIndex];
						finalKey = finalKey + originalIndex;
						if (ki < list.length - 1) {
							finalKey = finalKey + "_";
						}
					}
					if (Object.keys(indexesToTakeCombsMap).length === 0) {
						// it means that all the additionalTuple requirements has been satisfied. This key of original indexes is linked with this additionalTuple
						returnMap[finalKey] = additionalTuple;
					}
				}
			}
		}
		return returnMap;	
	}

};
window.additionalUkTuplesRules = additionalUkTuplesRules;


/** NB: THE ITALIAN TUPLES GOES FROM INDEX 1 TO 30. TO ADD THE UK TUPLES, FIRST I ENLARGE THE COMB ARRAY,
	THEN I ASSIGN THE ID STARTING FROM 31 TO THE FINAL ONE */
export function setAdditionalUkTuples(calculatedSystemData, totalDraws) {
	const combinations = calculatedSystemData.comb;
	let totalCombs = 0;
	for (let kc in combinations) {
		totalCombs += combinations[kc];
	}
	const tupleList = additionalUkTuplesRules.getAvaialableTuplesByOrdinaryCombinations(combinations, totalDraws);
	if (tupleList) {
		// increase the combination list to add the positions for the additional tuples
		const totalTuplesAvailable = additionalUkTuplesRules.getTotalTuplesToAddInList();
		for (let i = 0; i < totalTuplesAvailable.totalTuplesToAdd; i++) {
			combinations.push(0);
		}
		for (let it in tupleList) {
			let tupleCombs = 0;
			const tupla = tupleList[it];
			for (let i in tupla.indexesToTakeCombs) {
				const index = tupla.indexesToTakeCombs[i];
				if (index === 'all_valued') {
					tupleCombs += totalCombs;
				}
				else{
					tupleCombs += combinations[index];
				}
			}
			combinations[tupla.index] = tupleCombs;
		}
	}
	//window.combinations = combinations;
}


export function isUKCombinationMaskEnabled() {
	const conf = getConfiguration();
	return conf.ukce;
}

export function restoreTicketDataWithUkCombinations(ticketData, fromCheckbet) {
	try{
		let tuples = null;
		if (!fromCheckbet) {
			tuples = ticketData.tuples;
		}
		else{
			// it is from checkbet: I create an object to be processed by this algoritm
			tuples = [];
			
			for (let kt in ticketData.tuples) {
				const tupleCheckbet = ticketData.tuples[kt];
				const tuple = {
					amount: tupleCheckbet.amount,
					id: tupleCheckbet.npla,
					vMin: tupleCheckbet.minWinnings,
					vMax: tupleCheckbet.maxWinnings,
					combs: tupleCheckbet.combinations
				};
				tuples.push(tuple);
			}
			
		}
		 
		let totalDraws = 0;
		for (let ke in ticketData.events) {
			totalDraws += ticketData.events[ke].bets.length;
		}

		
		const subArraysContainer = {}; // key is the combination amount: to compose an additionalTuple with a set of original tuples, all the combination amounts must be equals
		const tuplesMap = {};
		for (let kt in tuples) {
			const tuple = tuples[kt];
			tuplesMap[tuple.id] = tuple;
			if (!subArraysContainer[tuple.amount]) {
				subArraysContainer[tuple.amount] = [];
			}
			subArraysContainer[tuple.amount].push(tuple.id);
		}
		
		const additionalTuplesMap = {};
		// sort the arrays and get the additionalTuples, if any
		for (let ka in subArraysContainer) {
			subArraysContainer[ka].sort();
			const additionalTuplesMapI = additionalUkTuplesRules.getAdditionalTuplesByIndexesList(subArraysContainer[ka]);
			for (let keyOriginalIndexes in additionalTuplesMapI) {
				additionalTuplesMap[keyOriginalIndexes] = additionalTuplesMapI[keyOriginalIndexes];
			}
		}
	
			// remove the original tuples, and adding the additional ones
		for (let kat in additionalTuplesMap) {
			const keys = kat.split("_");
			const additionalTuple = additionalTuplesMap[kat];
			let amount = 0;
			const combs = additionalTuple.totalCombsExpected;
			let vMin = 0;
			let vMax = 0;
			const id = additionalTuple.index;
			
			
			for (let k in keys) {
				const originalIndex = keys[k];
				amount = tuplesMap[originalIndex].amount;
				vMin += tuplesMap[originalIndex].vMin;
				vMax += tuplesMap[originalIndex].vMax;
				delete tuplesMap[originalIndex];
			}
			tuplesMap[id] = {
				id,
				amount,
				combs,
				vMin,
				vMax,
				isUk: true 
			};
		}
		let finalTuplesArray = [];
		
		for (let id in tuplesMap) {
			const tuple = tuplesMap[id];
			tuple.isAccumulator  = totalDraws == tuple.id;
			finalTuplesArray.push(tuple);
		}
		
		finalTuplesArray.sort((a, b) => {
			if (a.isAccumulator) {
				return -1;
			}
			if (a.id < b.id) {
				return -1;
			}
			if (a.id > b.id) {
				return 1;
			}
			
			return 0;
		});
		if (fromCheckbet) {
			const tups = [];
			// recreate the original dto
			for (let kt in finalTuplesArray) {
				const tuple = finalTuplesArray[kt];
				const tup = {
					amount: tuple.amount,
					npla: tuple.id,
					minWinnings: tuple.vMin,
					maxWinnings: tuple.vMax,
					combinations: tuple.combs,
					isUk: tuple.isUk,
					desc: tuple.id + "-" + getLabel('ticket.system.pla'),
					isAccumulator: tuple.isAccumulator
				};
				tups.push(tup);
			}
			finalTuplesArray = tups;
		}
		ticketData.tuples = finalTuplesArray;
	}
	catch(e) {
		console.error(e);
	}
	
}

window.printLabelsToAdd = function(prod, language) {
	let labels = {
		'uk_system_tuples.generic_accumulator': 'Accumulator',
		'uk_system_tuples.single_accumulator' : 'Single',
		'uk_system_tuples.double_accumulator' : 'Double',
		'uk_system_tuples.treble_accumulator' : 'Treble',
		'uk_system_tuples.singles'  	: 'Singles',
		'uk_system_tuples.doubles'  	: 'Doubles',
		'uk_system_tuples.trebles'  	: 'Trebles',
		'uk_system_tuples.generic_fold' : '{{COMB-ID}}-fold',
		'uk_system_tuples.trixie': 'Trixie',
		'uk_system_tuples.patent': 'Patent',
		'uk_system_tuples.yankee11': 'Yankee 11',
		'uk_system_tuples.lucky15': 'Lucky 15',
		'uk_system_tuples.canadian': 'Canadian',
		'uk_system_tuples.lucky31': 'Lucky 31',
		'uk_system_tuples.lucky63': 'Lucky 63',
		'uk_system_tuples.heinz': 'Heinz',
		'uk_system_tuples.yankee': 'TripleYankee',
		'uk_system_tuples.super_heinz': 'Superheinz',
		'uk_system_tuples.goliath': 'Goliath'
		
	};
	let string = '';
	for (let k in labels) {
		string = string + `(${prod}, 'DEFAULT', '${language.toUpperCase()}', 'ETICHETTA_SPORT_REACT', getdate(), null, '${k}', N'${labels[k]}'),\n`;
	}
	console.log(string);
}

export function restoreURL(url) {
	if (!url) {
		return '';
	}
	if (url.indexOf('http') >= 0 || url.indexOf('https') >= 0) {
		return url;
	}
	const barChar = url.startsWith("/")? "": "/";
	const fullUrl = window.location.protocol + "//" + window.location.host + barChar + url;
	return fullUrl;
}

export function getDatastoreWarName() {
	let dn = getEnv('REACT_APP_WAR_NAME') || 'XSportDatastore';
	if (dn.startsWith("/")) {
		dn = dn.substring(1);
	}
	return dn;
}

export function getAggregationAllId(sportId, isLive) {
		return (sportId * -1) - (isLive? 10000:0);
}

export function isLiveTrackerEnabled() {
    const conf = getConfiguration();
    if (conf.ltrkre == null) {
        return true;
    }
    return conf.ltrkre;
}

export function getCustomButtonsUrls() {
    const conf = getConfiguration();
    const cburls = conf.cburls;
    let customButtonsUrls = {};

    if (cburls == null || cburls.length === 0) {
        return customButtonsUrls;
    }

    try {
        customButtonsUrls = JSON.parse(cburls);
        customButtonsUrls = customButtonsUrls[xs_product_code];
    } catch(e) {}

    return customButtonsUrls;
}

export function nullOrEmptyObj(obj) {
    if (obj == null) {
        return true;
    }
    return obj.length === 0;
}

export function isLoadedInIframe() {
    const isLoadedInIframe =   getQueryStringVariable('isLoadedInIframe') == 'true';
    try {
        return isLoadedInIframe || window.self !== window.top;
    } catch (e) {
        return true;
    }
}

export function getTicketStatusDescription(status, cashout){
    let ticketStatus = null;
    switch(status){
        case 'opened':
            ticketStatus = getLabel('ticket.opened');
            break;
        case 'winning':
            ticketStatus = getLabel('ticket.winning');
            break;
        case 'winning_cashback':
            ticketStatus = getLabel('ticket.winning_cashback');
            break;
        case 'losing':
            ticketStatus = getLabel('ticket.losing');
            break;
        case 'voided':
            ticketStatus = getLabel('ticket.voided');
            break;
        case 'expired':
            ticketStatus = getLabel('ticket.expired');
        break;
        case 'paid':
            ticketStatus = cashout ? (getLabel('ticket.paid') + ' - ' + getLabel('cashout.button_text')) : getLabel('ticket.paid');
            break;
        default:
            break;
    }
	return ticketStatus;
}


export function formatStringWithSpaces(string, interval){
    // defaults to a space after 4 characters:
    interval = interval || 4;
    /* removes all characters in the value that aren't a number,
       or in the range from A to Z (uppercase): */
    let v = string.replace(/[^\dA-Z]/g, ''),
    /* creating the regular expression, to allow for the 'after' variable
       to be used/changed: */
    reg = new RegExp(".{" + interval + "}","g");
    string = v.replace(reg, function (a, b, c) {
        return a + ' ';
    }); 
    return string;
}

export function parseCookieSTCZ(value) {
	let toReturn = {};
	try {
		value?.split(";")?.forEach(v => {
			const s = v?.split("=");
			toReturn[''+s?.[0]] = s?.[1];
		})
	}catch(err) {
		console.error(err);
	}
	return toReturn;
}

export function levenshtein(a, b) {
    if (a == null || b == null) {
        return -1;
    }

    const lenA = a.length;
    const lenB = b.length;
    const dp = Array(lenA + 1).fill(null).map(() => Array(lenB + 1).fill(0));

    // Initialize base cases
    for (let i = 0; i <= lenA; i++) dp[i][0] = i;
    for (let j = 0; j <= lenB; j++) dp[0][j] = j;

    // Fill the dp table
    for (let i = 1; i <= lenA; i++) {
        for (let j = 1; j <= lenB; j++) {
            const cost = a[i - 1] === b[j - 1] ? 0 : 1;
            dp[i][j] = Math.min(
                dp[i - 1][j] + 1,    // Deletion
                dp[i][j - 1] + 1,    // Insertion
                dp[i - 1][j - 1] + cost // Substitution
            );
        }
    }

    return dp[lenA][lenB];
}

export function groupScorers(bets, team1, team2) {
    const teams = [];
    let scorersByTeam = new Map();
    
    // Group bets by team
    bets.forEach(b => {
        let team = '';
        let scorer = '';
        // Extract the team name from the full description
        const regex = /(?<scorer>.+?)\s*\(\s*(?<team>.+?)\s*\)/;
        if (regex.test(b.dia)) {
            const groups = regex.exec(b.dia).groups;
            team = groups.team;
            scorer = groups.scorer;
        }
    
        // The team was never encountered before
        if (!scorersByTeam.has(team)) {
            scorersByTeam.set(team, new Map());
            teams.push(team);
        } else {
        }
        const teamScorers = scorersByTeam.get(team);
        if (!teamScorers.has(scorer)) {
            teamScorers.set(scorer, []);
        }
        // Push the current bet to the related team
        teamScorers.get(scorer).push(b);
    });

    // If there are two teams, sort the bets so that the home team bets appear before the away team bets
    if (teams.length === 2) {
        // Temporary home/away teams (might be reversed)
        let [homeTeam, awayTeam] = [teams[0], teams[1]];

        // Compute the Levenshtein distance between the first team and the actual home/away team
        const distA = levenshtein(homeTeam, team1);
        const distB = levenshtein(homeTeam, team2);
    
        // If distB is the lower distance, then home and away teams must be swapped
        if (distB < distA) {
            [homeTeam, awayTeam] = [awayTeam, homeTeam];
        }

        let homeScorers = scorersByTeam.get(homeTeam);
        let awayScorers = scorersByTeam.get(awayTeam);

        function byName(a, b) {
            return a[0].localeCompare(b[0]);
        }
    
        function sortMap(map) {
            const a = Array.from(map);
            a.sort(byName);
            return new Map(a);
        }

        // Sort the scorers by name
        homeScorers = sortMap(homeScorers);
        awayScorers = sortMap(awayScorers);
    
        // Create a new map with the sorted scorers, by adding first the home team scorers and then the away team ones
        scorersByTeam = new Map();
        scorersByTeam.set(homeTeam, homeScorers);
        scorersByTeam.set(awayTeam, awayScorers);
    }

    // Convert map into array of objects
    const result = [];
    scorersByTeam.forEach((betsByScorer, team) => {
        const scorers = [];
        betsByScorer.forEach((bets, name) => {
            scorers.push({
                name,
                bets
            });
        });
        result.push({
            desc: team,
            scorers
        });
    });

    return result;
}

export function sortScorers(bets, team1, team2) {
    const teams = [];
    const betsByTeam = new Map();
    
    // Group bets by team
    bets.forEach(b => {
        let team = '';
        // Extract the team name from the full description
        const regex = /(?<scorer>.+?)\s*\(\s*(?<team>.+?)\s*\)/;
        if (regex.test(b.dia)) {
            const groups = regex.exec(b.dia).groups;
            team = groups.team;
        }

        // The team was never encountered before
        if (!betsByTeam.has(team)) {
            betsByTeam.set(team, []);
            teams.push(team);
        }
        // Push the current bet to the related team
        betsByTeam.get(team).push(b);
    });

    let result = bets;
    // If there are two teams, sort the bets so that the home team bets appear before the away team bets
    if (teams.length === 2) {
        // Temporary home/away teams (might be reversed)
        let [homeTeam, awayTeam] = [teams[0], teams[1]];

        // Compute the Levenshtein distance between the first team and the actual home/away team
        const distA = levenshtein(homeTeam, team1);
        const distB = levenshtein(homeTeam, team2);

        // If distB is the lower distance, then home and away teams must be swapped
        if (distB < distA) {
            [homeTeam, awayTeam] = [awayTeam, homeTeam];
        }

        let homeBets = betsByTeam.get(homeTeam);
        let awayBets = betsByTeam.get(awayTeam);

        function byDesc(a, b) {
            return a.dia.localeCompare(b.dia);
        }

        // Sort the bets of each team by full description
        homeBets.sort(byDesc);
        awayBets.sort(byDesc);
        // The final result is the home team bets followed by the away team bets
        result = homeBets.concat(awayBets);
    } else {
        // If we have either 1 team or > 2 teams, then we simply sort the bets by the full description
        result.sort(byDesc);
    }

    return result;
}
